import { FieldArray, Formik } from "formik";
import { useEffect, useState } from "react";
import Spin from "../../components/Spin";
import {
  API,
  fileUpload,
  PayeePayeerOptions,
  paymentMethods,
  taxOptions,
} from "../../config";
import { Button } from "../../components/ui/button";
import { Label } from "../../components/ui/label";
import { Input } from "../../components/ui/input";
import { Loader2, Plus, Trash2 } from "lucide-react";
import CustomLabelText from "../../components/CustomLabelText";
import { cn } from "../../lib/utils";
import ReactInputMask from "react-input-mask";
import { Textarea } from "../../components/ui/textarea";
import { DateInputPicker } from "../../components/DateInputPicker";
import { useMediaQuery } from "../../components/use-media-query";
import VendorSelect from "../../components/VendorSelect";
import {
  CalculateAmountExcGST,
  CalculateGST,
  formatBSBNumber,
  formatContactNameType,
  formatNumber,
  formatSubcontractorName,
  getModuleNamingBySlug,
} from "../../lib/Misc";
import ContactSelect from "../../components/ContactSelect";
// import JobSelect from "../../components/JobSelect";
// import TaskSelect from "../../components/TaskSelect";
import AssetSelect from "../../components/AssetSelect";
import SubAssetSelect from "../../components/SubAssetSelect";
import { AddPaymentSchema } from "../../lib/Validation";
import SupplierSelect from "../../components/SupplierSelect";
import BeneficarySelect from "../../components/BeneficarySelect";
import ContractSelect from "../../components/ContractSelect";
import moment from "moment";
import { useTrust } from "../../lib/context/TrustContext";
import { ReceiptItemSelectMulti } from "../../components/ReceiptItemSelectMulti";
import SearchSelect from "../../components/SearchSelect";
import { ResponsiveDrawerForm } from "../../components/ResponsiveDrawerForm";
// import Receipts from "../Receipts/Receipts";
import CustomTooltip from "../../components/CustomTooltip";
import { InfoCircledIcon } from "@radix-ui/react-icons";
import { useOrganization } from "../../lib/context/OrganisationContext";
import JobSelect from "../../components/JobSelect";
import TaskSelect from "../../components/TaskSelect";
import ReceiptItemsBasedOnSubAsset from "../Receipts/ReceiptItemsBasedOnSubAsset";
import { ToastAction } from "../../components/ui/toast";
import { useNavigate } from "react-router-dom";
import { useToast } from "../../components/ui/use-toast";
import { LawyerConditon } from "../../lib/PermissionConditions";

const AddEditPayment = ({
  id,
  toggleShowAddEditPayment,
  edit,
  fetchPaymentData,
  trustId,
  editItem,
}) => {
  const navigate = useNavigate();
  const { toast } = useToast();
  const [loading, setLoading] = useState(false);
  const { organizationData } = useOrganization();
  const isDesktop = useMediaQuery("(min-width: 1024px)");

  const { trustData: trustContextData } = useTrust();

  const [vendorLoading, setVendorLoading] = useState(false);
  const [vendorListing, setVendorListing] = useState([]);
  const [vendorList, setVendorList] = useState([]);

  const [contactLoading, setContactLoading] = useState(false);
  const [contactListing, setContactListing] = useState([]);
  const [contactList, setContactList] = useState([]);

  // const [jobLoading, setJobLoading] = useState(false);
  // const [jobListing, setJobListing] = useState([]);
  // const [jobList, setJobList] = useState([]);

  // const [taskLoading, setTaskLoading] = useState(false);
  // const [taskListing, setTaskListing] = useState([]);
  // const [taskList, setTaskList] = useState([]);

  const [supplierLoading, setSupplierLoading] = useState(false);
  const [supplierListing, setSupplierListing] = useState([]);
  const [supplierList, setSupplierList] = useState([]);

  const [listingHelper, setListingHelper] = useState([
    {
      asset: {
        listing: [],
        loading: false,
      },
      sub_asset: {
        listing: [],
        loading: false,
      },
      contract: {
        listing: [],
        loading: false,
      },
      receipt: {
        listing: [],
        loading: false,
      },
      beneficiary: {
        listing: [],
        loading: false,
      },
      job: {
        listing: [],
        loading: false,
      },
      task: {
        listing: [],
        loading: false,
      },
    },
  ]);

  const [showHistory, setShowHistory] = useState();
  const [historySubAssetId, setHistorySubAssetId] = useState();

  const toggleHistory = (subAssetId) => {
    setShowHistory(!showHistory);
    setHistorySubAssetId(subAssetId);
  };

  const handleFormSubmit = async (values) => {
    const formData = new FormData();

    formData.append("trust_id", trustId);

    formData.append(
      "transaction_date",
      moment(
        values?.transaction_date ? values?.transaction_date : new Date(),
      ).format("DD-MM-YYYY"),
    );
    formData.append("file_note", values?.file_note);
    formData.append("invoice_number", values?.invoice_number);
    formData.append("payee", values?.payee);

    formData.append(
      "total_amount_exc",
      values?.payments
        ?.flatMap((payment) => payment.payment_data)
        ?.reduce(
          (sum, item) => sum + Number(`${item?.amount}`.replace(/,/g, "")),
          0,
        )
        .toFixed(2),
    );

    formData.append(
      "total_amount",
      values?.payments
        ?.flatMap((payment) => payment.payment_data)
        ?.reduce(
          (sum, item) =>
            sum + Number(`${item?.total_amount}`.replace(/,/g, "")),
          0,
        )
        .toFixed(2),
    );

    formData.append(
      "total_tax_amount",
      values?.payments
        ?.flatMap((payment) => payment.payment_data)
        ?.reduce(
          (sum, item) => sum + Number(`${item?.tax_amount}`.replace(/,/g, "")),
          0,
        )
        .toFixed(2),
    );

    values?.payments.forEach((payment, i) => {
      formData.append(
        `payments[${i}][contact_id]`,
        payment?.contact_id ? payment?.contact_id : "",
      );
      formData.append(`payments[${i}][tax]`, payment?.tax ? payment?.tax : "1");
      formData.append(
        `payments[${i}][contract_id]`,
        payment?.contract_id ? payment?.contract_id : "",
      );
      formData.append(
        `payments[${i}][vendor_id]`,
        payment?.vendor_id ? payment?.vendor_id : "",
      );
      formData.append(
        `payments[${i}][asset_id]`,
        payment?.asset_id ? payment?.asset_id : "",
      );
      formData.append(
        `payments[${i}][sub_asset_id]`,
        payment?.sub_asset_id ? payment?.sub_asset_id : "",
      );
      for (let r = 0; r < payment?.receipt_id?.length; r++) {
        let subAssetData = listingHelper[i]?.sub_asset?.listing?.find(
          (item) => item?.value === values?.payments?.[i]?.sub_asset_id,
        );
        if (payment?.receipt_id[r] === subAssetData?.opening_balance?.id) {
          formData.append(`payments[${i}][opening_balance]`, 1);
        }
        formData.append(
          `payments[${i}][receipt_detail_ids][${r}]`,
          payment?.receipt_id[r] ? payment?.receipt_id[r] : "",
        );
      }

      formData.append(
        `payments[${i}][ts_job_id]`,
        payment?.ts_job_id ? payment?.ts_job_id : "",
      );
      formData.append(
        `payments[${i}][ts_task_id]`,
        payment?.ts_task_id ? payment?.ts_task_id : "",
      );

      formData.append(
        `payments[${i}][payment_method]`,
        payment?.payment_method ? payment?.payment_method : "",
      );

      payment?.payment_data.forEach((data, j) => {
        for (const key in data) {
          let value = data[key];

          if (key === "from" || key === "to") {
            value = value ? moment(value).format("DD-MM-YYYY") : "";
          }
          if (key === "bsb") {
            value = formatBSBNumber(value);
          }
          if (key === "trust" && value === true) {
            formData.append(`payments[${i}][payment_data][${j}][type]`, 0);
          } else if (key === "vendor" && value === true) {
            formData.append(`payments[${i}][payment_data][${j}][type]`, 1);
          } else if (key === "supplier" && value === true) {
            formData.append(`payments[${i}][payment_data][${j}][type]`, 2);
          } else if (key === "beneficiary" && value === true) {
            formData.append(`payments[${i}][payment_data][${j}][type]`, 3);
          } else if (key === "contact" && value === true) {
            formData.append(`payments[${i}][payment_data][${j}][type]`, 4);
          } else if (key === "total_amount") {
            formData.append(
              `payments[${i}][payment_data][${j}][amount]`,
              value ? value : "",
            );
          } else if (key === "amount") {
            formData.append(
              `payments[${i}][payment_data][${j}][amount_exc]`,
              value ? value : "",
            );
          } else {
            formData.append(
              `payments[${i}][payment_data][${j}][${key}]`,
              value ? value : "",
            );
          }
        }
      });
    });

    if (edit) {
      formData.append("_method", "put");
    }
    try {
      setLoading(true);
      const { data } = await fileUpload(
        `${API.CREATE_PAYMENTS}${edit ? `/${id}` : ""}`,
        formData,
      );
      setLoading(false);
      if (data) {
        toggleShowAddEditPayment();
        fetchPaymentData();
      }
      return data?.data;
    } catch (error) {
      setLoading(false);
    }
  };

  // Extract unique payment IDs
  const uniqueIds = editItem
    ? [...new Set(editItem?.payment_detail.map((item) => item.payment_id))]
    : [];
  let payments = uniqueIds;

  const initialValues = edit
    ? {
        transaction_date: moment(editItem?.transaction_date, "DD-MM-YYYY"),
        file_note: editItem?.file_note ? editItem?.file_note : "",
        invoice_number: editItem?.invoice_number
          ? editItem?.invoice_number
          : "",
        payee: editItem?.payeer ? editItem?.payeer : "vendor",
        payments: payments?.map((paymentItem) => {
          let paymentData = editItem?.payment_detail?.find(
            (item) => item?.payment_id === paymentItem,
          );
          return {
            vendor_id: paymentData?.vendor_id,
            asset_id: paymentData?.asset_id,
            sub_asset_id: paymentData?.sub_asset_id,
            contract_id: paymentData?.contract_id,
            contact_id: paymentData?.contact_id,
            tax: paymentData?.tax ? paymentData?.tax : "1",
            tax_percentage: paymentData?.sub_asset?.tax_percentage
              ? paymentData?.sub_asset?.tax_percentage
              : "0",
            ts_job_id: paymentData?.ts_job_id,
            ts_task_id: paymentData?.ts_task_id,
            payment_method: paymentData?.payment_method,
            receipt_id: editItem?.receipt_detail_ids,
            payment_data: editItem?.payment_detail?.map((paymentDetailItem) => {
              let paymnetDataObject = {
                id: paymentDetailItem?.id,
                contact_id:
                  paymentDetailItem?.beneficiary_id &&
                  paymentDetailItem?.type === "3"
                    ? paymentDetailItem?.beneficiary_id
                    : paymentDetailItem?.supplier_id &&
                        paymentDetailItem?.type === "2"
                      ? paymentDetailItem?.supplier_id
                      : paymentDetailItem?.vendor_id &&
                          paymentDetailItem?.type === "1"
                        ? paymentDetailItem?.vendor_id
                        : paymentDetailItem?.trust_id,
                contact_name: formatContactNameType(
                  paymentDetailItem,
                  organizationData?.organizationData,
                ),
                from: paymentDetailItem?.from
                  ? moment(paymentDetailItem?.from, "DD-MM-YYYY")
                  : "",
                to: paymentDetailItem?.to
                  ? moment(paymentDetailItem?.to, "DD-MM-YYYY")
                  : "",
                total_amount: paymentDetailItem?.amount
                  ? paymentDetailItem?.amount
                  : "",
                amount: paymentDetailItem?.amount
                  ? CalculateAmountExcGST(
                      "1",
                      paymentDetailItem?.tax,
                      paymentDetailItem?.amount,
                      paymentData?.sub_asset?.tax_percentage,
                    )
                  : "",
                tax_amount: paymentDetailItem?.amount
                  ? CalculateGST(
                      "1",
                      paymentDetailItem?.tax,
                      paymentDetailItem?.amount,
                      paymentData?.sub_asset?.tax_percentage,
                    )
                  : "",
                bsb: paymentDetailItem?.bsb ? paymentDetailItem?.bsb : "",
                account_name: paymentDetailItem?.account_name
                  ? paymentDetailItem?.account_name
                  : "",
                account_number: paymentDetailItem?.account_number
                  ? paymentDetailItem?.account_number
                  : "",

                description: paymentDetailItem?.description
                  ? paymentDetailItem?.description
                  : "",
              };

              paymentDetailItem?.beneficiary_id &&
              paymentDetailItem?.type === "3"
                ? (paymnetDataObject.beneficiary = true)
                : paymentDetailItem?.supplier_id &&
                    paymentDetailItem?.type === "2"
                  ? (paymnetDataObject.supplier = true)
                  : paymentDetailItem?.vendor_id &&
                      paymentDetailItem?.type === "1"
                    ? (paymnetDataObject.vendor = true)
                    : (paymnetDataObject.trust = true);

              return paymnetDataObject;
            }),
          };
        }),
      }
    : {
        transaction_date: "",
        file_note: "",
        payee: "vendor",
        invoice_number: "",
        tax: "1",
        tax_percentage: "",
        receipt_id: [],
        payments: [
          {
            contact_id: "",
            contract_id: "",
            vendor_id: "",
            asset_id: "",
            sub_asset_id: "",
            ts_job_id: "",
            ts_task_id: "",
            payment_method: 1,
            payment_data: [],
          },
        ],
      };

  useEffect(() => {
    if (vendorList) {
      let vendorTempListing = vendorList?.map((item) => ({
        ...item,
        value: item?.id,
        label: `${formatSubcontractorName(item)}${
          item?.code ? ` (${item?.code})` : ""
        }`,
      }));
      setVendorListing(vendorTempListing || []);
    } else {
      setVendorListing([]);
    }
  }, [vendorList]);

  useEffect(() => {
    if (contactList) {
      let contactTempListing = contactList?.map((item) => ({
        ...item,
        value: item.id,
        label: `${formatSubcontractorName(item)}${
          item?.code ? ` (${item?.code})` : ""
        }`,
      }));
      setContactListing(contactTempListing || []);
    } else {
      setContactListing([]);
    }
  }, [contactList]);

  const CheckTotal = (values, pIndex = 0) => {
    let receiptlist = listingHelper[pIndex]?.receipt?.listing?.filter(
      (item, index, self) =>
        index === self.findIndex((t) => t?.value === item?.value),
    );

    let receiptData = receiptlist?.filter((item) =>
      values?.payments?.[pIndex]?.receipt_id?.includes(item?.value),
    );

    let totalAmount = receiptData.reduce(
      (sum, item) => sum + item?.remaining_balance,
      0,
    );

    let paymentTotal = values?.payments?.[pIndex]?.payment_data?.reduce(
      (sum, p) => sum + Number(`${p?.total_amount}`.replace(/,/g, "")),
      0,
    );

    if (paymentTotal <= totalAmount) {
      return true;
    } else {
      return false;
    }
  };

  const ReceiptTotal = (values, pIndex = 0) => {
    let receiptlist = listingHelper[pIndex]?.receipt?.listing?.filter(
      (item, index, self) =>
        index === self.findIndex((t) => t?.value === item?.value),
    );

    let receiptData = receiptlist?.filter((item) =>
      values?.payments?.[pIndex].receipt_id.includes(item?.value),
    );

    let totalAmount = receiptData.reduce(
      (sum, item) => sum + item?.remaining_balance,
      0,
    );

    return totalAmount;
  };

  // useEffect(() => {
  //   if (jobList) {
  //     let jobTempListing = jobList?.map((item) => ({
  //       ...item,
  //       value: item.id,
  //       label: `${item?.title} ${item?.code ? `(${item?.code})` : ""}`,
  //     }));
  //     setJobListing(jobTempListing || []);
  //   } else {
  //     setJobListing([]);
  //   }
  // }, [jobList]);

  // useEffect(() => {
  //   if (taskList) {
  //     let taskTempListing = taskList?.map((item) => ({
  //       ...item,
  //       value: item.id,
  //       label: `${item?.title} ${item?.code ? `(${item?.code})` : ""}`,
  //     }));
  //     setTaskListing(taskTempListing || []);
  //   } else {
  //     setTaskListing([]);
  //   }
  // }, [taskList]);

  useEffect(() => {
    if (supplierList) {
      let supplierTempListing = supplierList?.map((item) => ({
        ...item,
        value: item.id,
        label: `${formatSubcontractorName(item)}${
          item?.code ? ` (${item?.code})` : ""
        }`,
      }));
      setSupplierListing(supplierTempListing || []);
    } else {
      setSupplierListing([]);
    }
  }, [supplierList]);

  // Vendor Functions
  function initalVendorAndTrustData({
    values,
    pIndex,
    vendorData,
    setFieldValue,
  }) {
    const paymentData = values?.payments?.[pIndex]?.payment_data || [];

    const newVendorData = {
      contact_id: vendorData?.id,
      contact_name:
        vendorData &&
        vendorData?.last_name &&
        formatSubcontractorName(vendorData),
      from: "",
      to: "",
      total_amount: "",
      amount: "",
      tax_amount: "",
      bsb: vendorData?.bsb,
      account_name: vendorData?.account_name,
      account_number: vendorData?.account_number,
      description: "",
      vendor: true,
    };

    const trustData = {
      contact_id: trustContextData?.id,
      contact_name: trustContextData?.business_name
        ? trustContextData?.business_name
        : trustContextData?.first_name
          ? trustContextData?.first_name + " " + trustContextData?.last_name
          : trustContextData?.last_name,
      from: "",
      to: "",
      total_amount: "",
      amount: "",
      tax_amount: "",
      bsb: trustContextData?.withdrawal_account?.bsb,
      account_name: trustContextData?.withdrawal_account?.account_name,
      account_number: trustContextData?.withdrawal_account?.account_number,
      description: "Professional Fees",
      trust: true,
    };

    let updatedPaymentData = [];

    if (paymentData.length === 0) {
      // Case: No existing data → Add both vendor and trust
      updatedPaymentData = [newVendorData, trustData];
    } else {
      // Case: Existing data → Update vendor
      updatedPaymentData = paymentData.map((item) => {
        if (item.vendor) {
          return newVendorData; // Replace existing vendor
        }
        return { ...item, total_amount: "", amount: "", tax_amount: "" }; // Keep trust or others
      });

      const vendorExists = paymentData.some((item) => item.vendor);
      if (!vendorExists) {
        updatedPaymentData = [newVendorData, ...updatedPaymentData];
      }

      const trustExists = paymentData.some((item) => item.trust);
      if (!trustExists) {
        updatedPaymentData = [...updatedPaymentData, trustData];
      }
    }

    // Finally update the form field
    setFieldValue(`payments.${pIndex}.payment_data`, updatedPaymentData);
  }

  function updateVendorAndTrustData({
    values,
    pIndex,
    vendorData,
    setFieldValue,
    // jointAccountData,
  }) {
    const paymentData = values?.payments?.[pIndex]?.payment_data || [];

    const newVendorData = {
      contact_id: vendorData?.id,
      contact_name:
        vendorData &&
        vendorData?.last_name &&
        formatSubcontractorName(vendorData),
      from: "",
      to: "",
      total_amount: "",
      amount: "",
      tax_amount: "",
      // bsb: jointAccountData?.bsb ? jointAccountData?.bsb : vendorData?.bsb,
      // account_name: jointAccountData?.account_name
      //   ? jointAccountData?.account_name
      //   : vendorData?.account_name,
      // account_number: jointAccountData?.account_number
      //   ? jointAccountData?.account_number
      //   : vendorData?.account_number,
      bsb: vendorData?.bsb,
      account_name: vendorData?.account_name,
      account_number: vendorData?.account_number,
      description: "",
      vendor: true,
    };

    const trustData = {
      contact_id: trustContextData?.id,
      contact_name: trustContextData?.business_name
        ? trustContextData?.business_name
        : trustContextData?.first_name
          ? trustContextData?.first_name + " " + trustContextData?.last_name
          : trustContextData?.last_name,
      from: "",
      to: "",
      total_amount: "",
      amount: "",
      tax_amount: "",
      bsb: trustContextData?.withdrawal_account?.bsb,
      account_name: trustContextData?.withdrawal_account?.account_name,
      account_number: trustContextData?.withdrawal_account?.account_number,
      description: "Professional Fees",
      trust: true,
    };

    let updatedPaymentData = [];

    if (paymentData.length === 0) {
      // Case: No existing data → Add both vendor and trust
      updatedPaymentData = [newVendorData, trustData];
    } else {
      // Case: Existing data → Update vendor
      updatedPaymentData = paymentData.map((item) => {
        if (item.vendor && !item.id) {
          return newVendorData; // Replace existing vendor
        } else if (item.vendor && item.id) {
          return {
            ...item,
            contact_id: newVendorData?.contact_id,
            contact_name: newVendorData?.contact_name,

            bsb: newVendorData?.bsb,
            account_name: newVendorData?.account_name,
            account_number: newVendorData?.account_number,
            vendor: true,
          };
        }
        return item; // Keep trust or others
      });

      const vendorExists = paymentData.some((item) => item.vendor);
      if (!vendorExists) {
        updatedPaymentData = [newVendorData, ...updatedPaymentData];
      }

      const trustExists = paymentData.some((item) => item.trust);
      if (!trustExists) {
        updatedPaymentData = [...updatedPaymentData, trustData];
      }
    }

    // Finally update the form field
    setFieldValue(`payments.${pIndex}.payment_data`, updatedPaymentData);
  }

  // Contact Functions
  function initalContactAndTrustData({
    values,
    pIndex,
    contactData,
    setFieldValue,
  }) {
    const paymentData = values?.payments?.[pIndex]?.payment_data || [];

    const newContactData = {
      contact_id: contactData?.id,
      contact_name:
        contactData &&
        contactData?.last_name &&
        formatSubcontractorName(contactData),
      from: "",
      to: "",
      total_amount: "",
      amount: "",
      tax_amount: "",
      bsb: contactData?.bsb,
      account_name: contactData?.account_name,
      account_number: contactData?.account_number,
      description: "",
      contact: true,
    };

    const trustData = {
      contact_id: trustContextData?.id,
      contact_name: trustContextData?.business_name
        ? trustContextData?.business_name
        : trustContextData?.first_name
          ? trustContextData?.first_name + " " + trustContextData?.last_name
          : trustContextData?.last_name,
      from: "",
      to: "",
      total_amount: "",
      amount: "",
      tax_amount: "",
      bsb: trustContextData?.withdrawal_account?.bsb,
      account_name: trustContextData?.withdrawal_account?.account_name,
      account_number: trustContextData?.withdrawal_account?.account_number,
      description: "Professional Fees",
      trust: true,
    };

    let updatedPaymentData = [];

    if (paymentData.length === 0) {
      // Case: No existing data → Add both vendor and trust
      updatedPaymentData = [newContactData, trustData];
    } else {
      // Case: Existing data → Update vendor
      updatedPaymentData = paymentData.map((item) => {
        if (item.contact) {
          return newContactData; // Replace existing vendor
        }
        return { ...item, total_amount: "", amount: "", tax_amount: "" }; // Keep trust or others
      });

      const contactExists = paymentData.some((item) => item.contact);
      if (!contactExists) {
        updatedPaymentData = [newContactData, ...updatedPaymentData];
      }

      const trustExists = paymentData.some((item) => item.trust);
      if (!trustExists) {
        updatedPaymentData = [...updatedPaymentData, trustData];
      }
    }

    // Finally update the form field
    setFieldValue(`payments.${pIndex}.payment_data`, updatedPaymentData);
  }

  function updateContactAndTrustData({
    values,
    pIndex,
    contactData,
    setFieldValue,
    // jointAccountData,
  }) {
    const paymentData = values?.payments?.[pIndex]?.payment_data || [];

    const newContactData = {
      contact_id: contactData?.id,
      contact_name:
        contactData &&
        contactData?.last_name &&
        formatSubcontractorName(contactData),
      from: "",
      to: "",
      total_amount: "",
      amount: "",
      tax_amount: "",
      // bsb: jointAccountData?.bsb ? jointAccountData?.bsb : contactData?.bsb,
      // account_name: jointAccountData?.account_name
      //   ? jointAccountData?.account_name
      //   : contactData?.account_name,
      // account_number: jointAccountData?.account_number
      //   ? jointAccountData?.account_number
      //   : contactData?.account_number,
      bsb: contactData?.bsb,
      account_name: contactData?.account_name,
      account_number: contactData?.account_number,
      description: "",
      contact: true,
    };

    const trustData = {
      contact_id: trustContextData?.id,
      contact_name: trustContextData?.business_name
        ? trustContextData?.business_name
        : trustContextData?.first_name
          ? trustContextData?.first_name + " " + trustContextData?.last_name
          : trustContextData?.last_name,
      from: "",
      to: "",
      total_amount: "",
      amount: "",
      tax_amount: "",
      bsb: trustContextData?.withdrawal_account?.bsb,
      account_name: trustContextData?.withdrawal_account?.account_name,
      account_number: trustContextData?.withdrawal_account?.account_number,
      description: "Professional Fees",
      trust: true,
    };

    let updatedPaymentData = [];

    if (paymentData.length === 0) {
      // Case: No existing data → Add both vendor and trust
      updatedPaymentData = [newContactData, trustData];
    } else {
      // Case: Existing data → Update vendor
      updatedPaymentData = paymentData.map((item) => {
        if (item.contact && !item.id) {
          return newContactData; // Replace existing vendor
        } else if (item.contact && item.id) {
          return {
            ...item,
            contact_id: newContactData?.contact_id,
            contact_name: newContactData?.contact_name,

            bsb: newContactData?.bsb,
            account_name: newContactData?.account_name,
            account_number: newContactData?.account_number,
            contact: true,
          };
        }
        return item; // Keep trust or others
      });

      const contactExists = paymentData.some((item) => item.contact);
      if (!contactExists) {
        updatedPaymentData = [newContactData, ...updatedPaymentData];
      }

      const trustExists = paymentData.some((item) => item.trust);
      if (!trustExists) {
        updatedPaymentData = [...updatedPaymentData, trustData];
      }
    }

    // Finally update the form field
    setFieldValue(`payments.${pIndex}.payment_data`, updatedPaymentData);
  }

  // eslint-disable-next-line no-unused-vars
  function updateSupplierAndTrustData({
    values,
    pIndex,
    // dIndex,
    supplierData,
    setFieldValue,
  }) {
    const paymentData = values?.payments?.[pIndex]?.payment_data || [];

    const newVendorData = {
      contact_id: supplierData?.id,
      contact_name:
        supplierData &&
        supplierData.last_name &&
        formatSubcontractorName(supplierData),
      from: "",
      to: "",
      total_amount: "",
      amount: "",
      tax_amount: "",
      bsb: supplierData?.bsb,
      account_name: supplierData?.account_name,
      account_number: supplierData?.account_number,
      description: "",
      supplier: true,
    };

    const trustData = {
      contact_id: trustContextData?.id,
      contact_name: trustContextData?.business_name
        ? trustContextData?.business_name
        : trustContextData?.first_name
          ? trustContextData?.first_name + " " + trustContextData?.last_name
          : trustContextData?.last_name,
      from: "",
      to: "",
      total_amount: "",
      amount: "",
      tax_amount: "",
      bsb: trustContextData?.withdrawal_account?.bsb,
      account_name: trustContextData?.withdrawal_account?.account_name,
      account_number: trustContextData?.withdrawal_account?.account_number,
      description: "Professional Fees",
      trust: true,
    };

    let updatedPaymentData = [];

    if (paymentData.length === 0) {
      // Case: No existing data → Add both supplier and trust
      updatedPaymentData = [newVendorData, trustData];
    } else {
      // Case: Existing data → Update supplier
      updatedPaymentData = paymentData.map((item) => {
        if (item.supplier && !item.id) {
          return newVendorData; // Replace existing supplier
        } else if (item.supplier && item.id) {
          return {
            ...item,
            contact_id: newVendorData?.contact_id,
            contact_name: newVendorData?.contact_name,
            bsb: newVendorData?.bsb,
            account_name: newVendorData?.account_name,
            account_number: newVendorData?.account_number,
            supplier: true,
          };
        }
        return item; // Keep trust or others
      });

      const supplierExists = paymentData.some((item) => item.supplier);
      if (!supplierExists) {
        updatedPaymentData = [newVendorData, ...updatedPaymentData];
      }

      // const trustExists = paymentData.some((item) => item.trust);
      // if (!trustExists) {
      //   updatedPaymentData = [...updatedPaymentData, trustData];
      // }
    }

    // Finally update the form field
    setFieldValue(`payments.${pIndex}.payment_data`, updatedPaymentData);
  }

  return (
    <Formik
      initialValues={initialValues}
      enableReinitialize
      onSubmit={handleFormSubmit}
      validateOnBlur={true}
      validateOnChange={true}
      validationSchema={AddPaymentSchema(organizationData)}
      validate={async (values) => {
        try {
          await AddPaymentSchema(organizationData).validate(values, {
            abortEarly: false,
            context: { payee: values?.payee },
          });
          return {};
        } catch (err) {
          const errors = {};
          err.inner?.forEach((e) => {
            if (e.path) errors[e.path] = e.message;
          });
          return errors;
        }
      }}
    >
      {({
        values,
        errors,
        handleChange,
        handleBlur,
        handleSubmit,
        setFieldValue,
        isValid,
      }) => (
        <>
          {loading && <Spin expand={true} fullscreen={true} />}
          <form
            onSubmit={handleSubmit}
            noValidate
            className="entry-section md:m-0 m-5"
          >
            <div className="form-box flex max-h-[78vh] bg-muted flex-col gap-4 overflow-y-auto overflow-x-hidden p-2 border rounded-lg">
              <div className="border bg-background rounded-md p-2 shadow-sm space-y-2 flex w-full items-center flex-wrap">
                <div className="flex-1 flex items-center gap-2 flex-wrap">
                  <div className="grid gap-2">
                    <Label htmlFor="file_note">
                      <CustomLabelText
                        required={true}
                        labelText="Transaction Date"
                        errorField={errors?.transaction_date}
                      />
                    </Label>
                    <DateInputPicker
                      date={
                        values?.transaction_date
                          ? values?.transaction_date
                          : new Date()
                      }
                      onSelect={(e) => {
                        setFieldValue("transaction_date", e);
                      }}
                      className={"text-left"}
                      icon={false}
                      disabledDate={{ after: new Date() }}
                    />
                  </div>
                  <div className="grid gap-2">
                    <Label htmlFor="file_note">
                      <CustomLabelText
                        required={false}
                        // labelText="File Note"
                        labelText={
                          LawyerConditon(organizationData)
                            ? "Matter Reference"
                            : "File Note"
                        }
                        errorField={errors?.file_note}
                        bottomAlign={true}
                      />
                    </Label>
                    <Input
                      type="text"
                      name="file_note"
                      value={values?.file_note ? values?.file_note : ""}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      autoComplete="off"
                      onKeyPress={(e) => {
                        e.which === 13 && e.preventDefault();
                      }}
                      className={
                        errors?.file_note &&
                        `focus-visible:ring-red-500 border-red-500`
                      }
                    />
                  </div>
                  <div className="grid gap-2">
                    <Label htmlFor="invoice_number">
                      <CustomLabelText
                        required={false}
                        labelText="Invoice Number"
                        errorField={errors?.invoice_number}
                        bottomAlign={true}
                      />
                    </Label>
                    <Input
                      type="text"
                      name="invoice_number"
                      value={
                        values?.invoice_number ? values?.invoice_number : ""
                      }
                      onChange={handleChange}
                      onBlur={handleBlur}
                      autoComplete="off"
                      onKeyPress={(e) => {
                        e.which === 13 && e.preventDefault();
                      }}
                      className={
                        errors?.invoice_number &&
                        `focus-visible:ring-red-500 border-red-500`
                      }
                    />
                  </div>
                  <div className="grid gap-2">
                    <div className="min-w-0">
                      <Label htmlFor="payee">
                        <CustomLabelText
                          required={true}
                          labelText="Payee"
                          errorField={errors?.payee}
                        />
                      </Label>
                      <div className="relative mt-2">
                        <SearchSelect
                          frameworks={PayeePayeerOptions(organizationData)}
                          optionType={"Payee"}
                          handleSelect={(e) => {
                            setFieldValue(`payee`, e);

                            setFieldValue(`payments`, [
                              {
                                contact_id: "",
                                contract_id: "",
                                vendor_id: "",
                                asset_id: "",
                                sub_asset_id: "",
                                ts_job_id: "",
                                ts_task_id: "",
                                payment_method: 1,
                                payment_data: [],
                              },
                            ]);

                            setListingHelper([
                              {
                                asset: {
                                  listing: [],
                                  loading: false,
                                },
                                sub_asset: {
                                  listing: [],
                                  loading: false,
                                },
                                contract: {
                                  listing: [],
                                  loading: false,
                                },
                                receipt: {
                                  listing: [],
                                  loading: false,
                                },
                                beneficiary: {
                                  listing: [],
                                  loading: false,
                                },
                                job: {
                                  listing: [],
                                  loading: false,
                                },
                                task: {
                                  listing: [],
                                  loading: false,
                                },
                              },
                            ]);
                          }}
                          handleBlur={handleBlur}
                          className={
                            errors?.payee &&
                            `focus-visible:ring-red-500 border-red-500`
                          }
                          disabled={false}
                          initialValue={values?.payee}
                        />
                      </div>
                    </div>
                  </div>
                </div>

                <div className="bg-webPrimary text-white text-sm px-2 rounded-md">
                  Payment Total (Inc): $
                  {values?.payments
                    ?.flatMap((payment) => payment.payment_data)
                    ?.reduce(
                      (sum, item) =>
                        sum + Number(`${item?.total_amount}`.replace(/,/g, "")),
                      0,
                    )
                    ? formatNumber(
                        values?.payments
                          ?.flatMap((payment) => payment.payment_data)
                          ?.reduce(
                            (sum, item) =>
                              sum +
                              Number(`${item?.total_amount}`.replace(/,/g, "")),
                            0,
                          ),
                      )
                    : "0.00"}
                </div>
                {/* <div className="bg-webPrimary text-white px-2 rounded-md">
                  Total of .ABA file:{" "}
                  {formatNumber(
                    values?.payments
                      ?.flatMap((payment) => payment.payment_data)
                      ?.reduce(
                        (sum, item) =>
                          sum + Number(`${item?.amount}`.replace(/,/g, "")),
                        0
                      )
                  )}
                </div> */}
              </div>
              <FieldArray name="payments">
                {({ push, remove }) => (
                  <>
                    {values.payments.map((payment, pIndex) => (
                      <div
                        key={pIndex}
                        className="border bg-background rounded-md p-2 shadow-sm space-y-2"
                      >
                        <div className="flex justify-between items-center">
                          <h4 className="font-semibold">
                            Payment{" "}
                            <span className="text-webPrimary">
                              #{pIndex + 1}
                            </span>
                          </h4>
                          <div className="flex items-center gap-2">
                            {values?.payments?.[pIndex]?.sub_asset_id && (
                              <div className="flex items-center gap-2">
                                {/* {!editItem && ( */}
                                <div className="bg-webPrimary text-white text-sm px-2 rounded-md">
                                  Balance (Inc):{" "}
                                  {listingHelper[
                                    pIndex
                                  ]?.sub_asset?.listing?.find(
                                    (item) =>
                                      item?.id ===
                                      values?.payments?.[pIndex]?.sub_asset_id,
                                  )?.receipt_details_total
                                    ? `$${formatNumber(
                                        Number(
                                          listingHelper[
                                            pIndex
                                          ]?.sub_asset?.listing?.find(
                                            (item) =>
                                              item?.id ===
                                              values?.payments?.[pIndex]
                                                ?.sub_asset_id,
                                          )?.receipt_details_total,
                                        ),
                                      )}`
                                    : "$0.00"}
                                </div>
                                {/* )} */}
                                {/* {!editItem && ( */}
                                <div className="bg-green-500 text-white text-sm px-2 rounded-md">
                                  Balance After Payment (Inc):{" "}
                                  {formatNumber(
                                    values?.payments?.[
                                      pIndex
                                    ]?.payment_data?.reduce(
                                      (sum, p) =>
                                        sum +
                                        Number(
                                          `${p?.total_amount}`.replace(
                                            /,/g,
                                            "",
                                          ),
                                        ),
                                      0,
                                    ),
                                  )
                                    ? `$${formatNumber(
                                        Number(
                                          listingHelper[
                                            pIndex
                                          ]?.sub_asset?.listing?.find(
                                            (item) =>
                                              item?.id ===
                                              values?.payments?.[pIndex]
                                                ?.sub_asset_id,
                                          )?.receipt_details_total
                                            ? Number(
                                                listingHelper[
                                                  pIndex
                                                ]?.sub_asset?.listing?.find(
                                                  (item) =>
                                                    item?.id ===
                                                    values?.payments?.[pIndex]
                                                      ?.sub_asset_id,
                                                )?.receipt_details_total,
                                              )
                                            : 0,
                                        ) -
                                          values?.payments?.[
                                            pIndex
                                          ]?.payment_data?.reduce(
                                            (sum, p) =>
                                              sum +
                                              Number(
                                                `${p?.total_amount}`.replace(
                                                  /,/g,
                                                  "",
                                                ),
                                              ),
                                            0,
                                          ),
                                      )}`
                                    : `$0.00`}
                                </div>
                                {/* )} */}
                                <div
                                  className={`
                                  ${
                                    CheckTotal(values, pIndex)
                                      ? "dark:bg-white dark:text-black bg-black text-white"
                                      : "bg-red-500 text-white"
                                  }
                                   text-sm px-2 rounded-md`}
                                >
                                  Total Payment (Inc):{" "}
                                  {formatNumber(
                                    values?.payments?.[
                                      pIndex
                                    ]?.payment_data?.reduce(
                                      (sum, p) =>
                                        sum +
                                        Number(
                                          `${p?.total_amount}`.replace(
                                            /,/g,
                                            "",
                                          ),
                                        ),
                                      0,
                                    ),
                                  )
                                    ? `$${formatNumber(
                                        values?.payments?.[
                                          pIndex
                                        ]?.payment_data?.reduce(
                                          (sum, p) =>
                                            sum +
                                            Number(
                                              `${p?.total_amount}`.replace(
                                                /,/g,
                                                "",
                                              ),
                                            ),
                                          0,
                                        ),
                                      )}`
                                    : `$0.00`}
                                </div>
                                {/* {values?.payments?.[pIndex]?.receipt_id
                                  ?.length > 0 && (
                                  <div
                                    className={`dark:bg-white dark:text-black bg-black text-white text-sm px-2 rounded-md`}
                                  >
                                    Total Receipt (Inc):{" "}
                                    {formatNumber(ReceiptTotal(values, pIndex))
                                      ? `$${formatNumber(
                                          ReceiptTotal(values, pIndex)
                                        )}`
                                      : `$0.00`}
                                  </div>
                                )} */}
                              </div>
                            )}
                            {pIndex + 1 === values?.payments?.length && (
                              <Button
                                type="button"
                                size="icon"
                                onClick={() => {
                                  push({
                                    transaction_date: "",
                                    file_note: "",
                                    invoice_number: "",
                                    tax: "1",
                                    tax_percentage: "",
                                    receipt_id: [],
                                    payments: [
                                      {
                                        contact_id: "",
                                        contract_id: "",
                                        vendor_id: "",
                                        asset_id: "",
                                        sub_asset_id: "",
                                        ts_job_id: "",
                                        ts_task_id: "",
                                        payment_method: 1,
                                        payment_data: [],
                                      },
                                    ],
                                  });

                                  setListingHelper((pre) => [
                                    ...pre,
                                    {
                                      asset: {
                                        listing: [],
                                        loading: false,
                                      },
                                      sub_asset: {
                                        listing: [],
                                        loading: false,
                                      },
                                      contract: {
                                        listing: [],
                                        loading: false,
                                      },
                                      job: {
                                        listing: [],
                                        loading: false,
                                      },
                                      task: {
                                        listing: [],
                                        loading: false,
                                      },

                                      receipt: {
                                        listing: [],
                                        loading: false,
                                      },
                                      beneficiary: {
                                        listing: [],
                                        loading: false,
                                      },
                                    },
                                  ]);
                                }}
                                className="h-6 w-6"
                              >
                                <Plus className="h-4 w-4" />
                              </Button>
                            )}
                            <Button
                              type="button"
                              variant="destructive"
                              size="icon"
                              onClick={() => {
                                remove(pIndex);
                                setListingHelper((prev) =>
                                  prev.filter((_, index) => index !== pIndex),
                                );
                              }}
                              className="h-6 w-6"
                            >
                              <Trash2 className="h-4 w-4" />
                            </Button>
                          </div>
                        </div>

                        {/* Payment Info Fields */}
                        <div className="grid lg:grid-cols-4 sm:grid-cols-2 gap-4">
                          {/* <div className="grid gap-2">
                            <div className="min-w-0">
                              <Label htmlFor="asset_id">
                                <CustomLabelText
                                  required={true}
                                  labelText={getModuleNamingBySlug(
                                    organizationData?.organizationData,
                                    "sub-assets",
                                    "Sub Asset"
                                  )}
                                  errorField={
                                    errors?.payments?.[pIndex]?.sub_asset_id
                                  }
                                />
                              </Label>
                              <div className="relative mt-2">
                                <SubAssetSelect
                                  trustId={trustId}
                                  assetId={""}
                                  editItem={editItem}
                                  payment_id={id}
                                  frameworkData={
                                    listingHelper[pIndex]?.sub_asset?.listing
                                      ? listingHelper[pIndex]?.sub_asset
                                          ?.listing
                                      : []
                                  } // List of vendors
                                  optionType={getModuleNamingBySlug(
                                    organizationData?.organizationData,
                                    "sub-assets",
                                    "Sub Asset"
                                  )}
                                  handleSelect={(e) => {
                                    let subAssetData = listingHelper[
                                      pIndex
                                    ]?.sub_asset?.listing?.find(
                                      (item) => item.value === e
                                    );
                                    setFieldValue(
                                      `payments.${pIndex}.tax_percentage`,
                                      subAssetData?.tax_percentage
                                    );
                                    setFieldValue(
                                      `payments.${pIndex}.tax`,
                                      subAssetData?.tax_type
                                    );

                                    setFieldValue(
                                      `payments.${pIndex}.sub_asset_id`,
                                      e
                                    );
                                    setFieldValue(
                                      `payments.${pIndex}.contract_id`,
                                      ""
                                    );
                                    setFieldValue(
                                      `payments.${pIndex}.receipt_id`,
                                      subAssetData?.receipt_ids
                                    );

                                    let totalAmount =
                                      subAssetData?.receipt_details_total
                                        ? subAssetData?.receipt_details_total
                                        : "";

                                    let gst_price = CalculateGST(
                                      "1",
                                      values?.payments?.[pIndex]?.tax,
                                      totalAmount,
                                      subAssetData?.tax_percentage
                                    );

                                    let amount_inc = CalculateAmountExcGST(
                                      "1",
                                      values?.payments?.[pIndex]?.tax,
                                      totalAmount,
                                      subAssetData?.tax_percentage
                                    );

                                    // let vendorData = vendorListing?.find(
                                    //   (item) =>
                                    //     item.value ===
                                    //     values?.payments?.[pIndex]?.vendor_id
                                    // );

                                    let vendorData = vendorListing?.find(
                                      (item) =>
                                        item.value === subAssetData?.vendor_id
                                    );

                                    initalVendorAndTrustData({
                                      values,
                                      pIndex,
                                      vendorData,
                                      setFieldValue,
                                    });

                                    values?.payments?.[pIndex]?.payment_data
                                      ?.length > 0 &&
                                      setFieldValue(
                                        `payments.${pIndex}.payment_data.${0}.total_amount`,
                                        totalAmount
                                      );

                                    values?.payments?.[pIndex]?.payment_data
                                      ?.length > 0 &&
                                      setFieldValue(
                                        `payments.${pIndex}.payment_data.${0}.amount`,
                                        amount_inc
                                      );

                                    values?.payments?.[pIndex]?.payment_data
                                      ?.length > 0 &&
                                      setFieldValue(
                                        `payments.${pIndex}.payment_data.${0}.tax_amount`,
                                        gst_price
                                      );

                                    setListingHelper((prev) =>
                                      prev.map((item, index) =>
                                        index === pIndex
                                          ? {
                                              ...item,
                                              contract: {
                                                ...item.contract,
                                                listing: [],
                                              },
                                            }
                                          : item
                                      )
                                    );
                                    setListingHelper((prev) =>
                                      prev.map((item, index) =>
                                        index === pIndex
                                          ? {
                                              ...item,
                                              receipt: {
                                                ...item.receipt,
                                                listing: [],
                                              },
                                            }
                                          : item
                                      )
                                    );

                                    setFieldValue(
                                      `payments.${pIndex}.asset_id`,
                                      subAssetData?.asset_id
                                    );
                                    setListingHelper((prev) =>
                                      prev.map((item, index) =>
                                        index === pIndex
                                          ? {
                                              ...item,
                                              asset: {
                                                ...item.asset,
                                                listing: [
                                                  {
                                                    ...subAssetData?.asset,
                                                    label: subAssetData?.asset
                                                      ?.name
                                                      ? subAssetData?.asset
                                                          ?.name
                                                      : "",
                                                    value:
                                                      subAssetData?.asset_id
                                                        ? subAssetData?.asset_id
                                                        : "",
                                                  },
                                                ],
                                              },
                                            }
                                          : item
                                      )
                                    );

                                    setFieldValue(
                                      `payments.${pIndex}.vendor_id`,
                                      subAssetData?.vendor_id
                                    );
                                  }}
                                  name="sub_asset_id"
                                  disabled={false}
                                  initialValue={
                                    values?.payments?.[pIndex]?.sub_asset_id
                                      ? values?.payments?.[pIndex]?.sub_asset_id
                                      : ""
                                  }
                                  setListingHelper={setListingHelper}
                                  targetIndex={pIndex}
                                  setSubAssetList={false}
                                  setSubAssetLoading={(e) => {
                                    setListingHelper((prev) =>
                                      prev.map((item, index) =>
                                        index === pIndex
                                          ? {
                                              ...item,
                                              sub_asset: {
                                                ...item.sub_asset,
                                                loading: e,
                                              },
                                            }
                                          : item
                                      )
                                    );
                                  }} // Control loading state
                                  onClear={() => {
                                    setFieldValue(
                                      `payments.${pIndex}.sub_asset_id`,
                                      ""
                                    );
                                    setFieldValue(
                                      `payments.${pIndex}.tax_percentage`,
                                      ""
                                    );
                                    setFieldValue(`payments.${pIndex}.tax`, "");
                                    setFieldValue(
                                      `payments.${pIndex}.contract_id`,
                                      ""
                                    );
                                    setFieldValue(
                                      `payments.${pIndex}.receipt_id`,
                                      ""
                                    );
                                    setListingHelper((prev) =>
                                      prev.map((item, index) =>
                                        index === pIndex
                                          ? {
                                              ...item,
                                              contract: {
                                                ...item.contract,
                                                listing: [],
                                              },
                                            }
                                          : item
                                      )
                                    );
                                    setListingHelper((prev) =>
                                      prev.map((item, index) =>
                                        index === pIndex
                                          ? {
                                              ...item,
                                              receipt: {
                                                ...item.receipt,
                                                listing: [],
                                              },
                                            }
                                          : item
                                      )
                                    );

                                    setFieldValue(
                                      `payments.${pIndex}.asset_id`,
                                      ""
                                    );
                                    setListingHelper((prev) =>
                                      prev.map((item, index) =>
                                        index === pIndex
                                          ? {
                                              ...item,
                                              asset: {
                                                ...item.asset,
                                                listing: [],
                                              },
                                            }
                                          : item
                                      )
                                    );

                                    setFieldValue(
                                      `payments.${pIndex}.vendor_id`,
                                      ""
                                    );
                                  }}
                                  className={
                                    errors?.payments?.[pIndex]?.sub_asset_id &&
                                    `focus-visible:ring-red-500 border-red-500`
                                  }
                                  loading={
                                    listingHelper?.[pIndex]?.sub_asset?.loading
                                  }
                                />
                                {listingHelper?.[pIndex]?.sub_asset
                                  ?.loading && (
                                  <span className="absolute top-2 right-2 animate-spin">
                                    <Loader2 width={20} height={20} />
                                  </span>
                                )}
                              </div>
                            </div>
                          </div> */}

                          <div className="grid gap-2">
                            <div className="min-w-0">
                              <Label htmlFor="vendor_id">
                                <CustomLabelText
                                  labelText={getModuleNamingBySlug(
                                    organizationData?.organizationData,
                                    "vendors",
                                    "Vendor",
                                  )}
                                  errorField={
                                    errors?.payments?.[pIndex]?.vendor_id
                                  }
                                  required={true}
                                />
                              </Label>
                              <div className="relative mt-2">
                                <VendorSelect
                                  trustId={trustId}
                                  frameworkData={vendorListing} // List of vendors
                                  optionType={getModuleNamingBySlug(
                                    organizationData?.organizationData,
                                    "vendors",
                                    "Vendor",
                                  )}
                                  handleSelect={(e) => {
                                    let vendorData = vendorListing?.find(
                                      (item) => item?.value === e,
                                    );
                                    setFieldValue(
                                      `payments.${pIndex}.vendor_id`,
                                      e,
                                    );
                                    setFieldValue(
                                      `payments.${pIndex}.asset_id`,
                                      "",
                                    );
                                    setFieldValue(
                                      `payments.${pIndex}.sub_asset_id`,
                                      "",
                                    );
                                    setFieldValue(
                                      `payments.${pIndex}.contract_id`,
                                      "",
                                    );
                                    setFieldValue(
                                      `payments.${pIndex}.receipt_id`,
                                      "",
                                    );

                                    setFieldValue(
                                      `payments.${pIndex}.listingHelper.asset.listing`,
                                      [],
                                    );

                                    setFieldValue(
                                      `payments.${pIndex}.listingHelper.sub_asset.listing`,
                                      [],
                                    );

                                    setFieldValue(
                                      `payments.${pIndex}.listingHelper.contract.listing`,
                                      [],
                                    );

                                    setFieldValue(
                                      `payments.${pIndex}.listingHelper.receipt.listing`,
                                      [],
                                    );

                                    setFieldValue(
                                      `payments.${pIndex}.listingHelper.beneficiary.listing`,
                                      [],
                                    );

                                    setListingHelper((prev) =>
                                      prev.map((item, index) =>
                                        index === pIndex
                                          ? {
                                              ...item,
                                              asset: {
                                                ...item.asset,
                                                listing: [],
                                              },
                                              sub_asset: {
                                                ...item.sub_asset,
                                                listing: [],
                                              },
                                              contract: {
                                                ...item.contract,
                                                listing: [],
                                              },
                                              receipt: {
                                                ...item.receipt,
                                                listing: [],
                                              },
                                              beneficiary: {
                                                ...item.beneficiary,
                                                listing: [],
                                              },
                                            }
                                          : item,
                                      ),
                                    );

                                    if (values?.payee === "vendor") {
                                      updateVendorAndTrustData({
                                        values,
                                        pIndex,
                                        vendorData,
                                        setFieldValue,
                                      });
                                    }

                                    if (!vendorData?.bank_id) {
                                      toast({
                                        variant: "primary",
                                        title: "Bank Details are missing",
                                        description: `To enter bank details of ${formatSubcontractorName(
                                          vendorData,
                                        )}`,
                                        duration: 5000,
                                        action: (
                                          <ToastAction
                                            altText="Enter"
                                            className="hover:text-black"
                                            onClick={() => {
                                              navigate(
                                                `/trusts/${trustId}/vendors`,
                                                {
                                                  state: {
                                                    vendorId: e,
                                                  },
                                                },
                                              );
                                            }}
                                          >
                                            Add
                                          </ToastAction>
                                        ),
                                      });
                                    }
                                  }}
                                  name="vendor_id"
                                  disabled={
                                    false ||
                                    listingHelper?.[pIndex]?.asset?.loading ||
                                    listingHelper?.[pIndex]?.sub_asset?.loading
                                  }
                                  // disabled={true}
                                  initialValue={
                                    values?.payments?.[pIndex]?.vendor_id
                                      ? values?.payments?.[pIndex]?.vendor_id
                                      : ""
                                  }
                                  setVendorList={setVendorList} // Update vendor list as new data loads
                                  setVendorLoading={setVendorLoading} // Control loading state
                                  onClear={() => {
                                    setFieldValue(
                                      `payments.${pIndex}.vendor_id`,
                                      "",
                                    );
                                    setFieldValue(
                                      `payments.${pIndex}.asset_id`,
                                      "",
                                    );
                                    setFieldValue(
                                      `payments.${pIndex}.sub_asset_id`,
                                      "",
                                    );

                                    setFieldValue(
                                      `payments.${pIndex}.contract_id`,
                                      "",
                                    );

                                    setFieldValue(
                                      `payments.${pIndex}.receipt_id`,
                                      "",
                                    );

                                    setFieldValue(
                                      `payments.${pIndex}.listingHelper.asset.listing`,
                                      [],
                                    );
                                    setFieldValue(
                                      `payments.${pIndex}.listingHelper.sub_asset.listing`,
                                      [],
                                    );

                                    setFieldValue(
                                      `payments.${pIndex}.listingHelper.contract.listing`,
                                      [],
                                    );

                                    setFieldValue(
                                      `payments.${pIndex}.listingHelper.receipt.listing`,
                                      [],
                                    );

                                    setFieldValue(
                                      `payments.${pIndex}.listingHelper.beneficiary.listing`,
                                      [],
                                    );
                                    setFieldValue(
                                      `payments.${pIndex}.payment_data`,
                                      [],
                                    );

                                    setListingHelper((prev) =>
                                      prev.map((item, index) =>
                                        index === pIndex
                                          ? {
                                              ...item,
                                              asset: {
                                                ...item.asset,
                                                listing: [],
                                              },
                                              sub_asset: {
                                                ...item.sub_asset,
                                                listing: [],
                                              },
                                              contract: {
                                                ...item.contract,
                                                listing: [],
                                              },
                                              receipt: {
                                                ...item.receipt,
                                                listing: [],
                                              },
                                              beneficiary: {
                                                ...item.beneficiary,
                                                listing: [],
                                              },
                                            }
                                          : item,
                                      ),
                                    );
                                  }}
                                  className={
                                    errors?.payments?.[pIndex]?.vendor_id &&
                                    `focus-visible:ring-red-500 border-red-500`
                                  }
                                  loading={vendorLoading}
                                />
                                {vendorLoading && (
                                  <span className="absolute top-2 right-2 animate-spin">
                                    <Loader2 width={20} height={20} />
                                  </span>
                                )}
                              </div>
                            </div>
                          </div>

                          <div className="grid gap-2">
                            <div className="min-w-0">
                              <Label htmlFor="asset_id">
                                <CustomLabelText
                                  labelText={getModuleNamingBySlug(
                                    organizationData?.organizationData,
                                    "assets",
                                    "Asset",
                                  )}
                                  errorField={
                                    errors?.payments?.[pIndex]?.asset_id
                                  }
                                  required={true}
                                />
                              </Label>
                              <div className="mt-2 relative">
                                <AssetSelect
                                  trustId={trustId}
                                  vendorId={
                                    values?.payments?.[pIndex]?.vendor_id
                                      ? values?.payments?.[pIndex]?.vendor_id
                                      : ""
                                  }
                                  frameworkData={
                                    listingHelper?.[pIndex]?.asset?.listing
                                      ? listingHelper?.[pIndex]?.asset?.listing
                                      : []
                                  }
                                  optionType={getModuleNamingBySlug(
                                    organizationData?.organizationData,
                                    "assets",
                                    "Asset",
                                  )}
                                  handleSelect={(e) => {
                                    setFieldValue(
                                      `payments.${pIndex}.asset_id`,
                                      e,
                                    );
                                    setFieldValue(
                                      `payments.${pIndex}.sub_asset_id`,
                                      "",
                                    );
                                    setFieldValue(
                                      `payments.${pIndex}.contract_id`,
                                      "",
                                    );
                                    setFieldValue(
                                      `payments.${pIndex}.receipt_id`,
                                      "",
                                    );
                                    setListingHelper((prev) =>
                                      prev.map((item, index) =>
                                        index === pIndex
                                          ? {
                                              ...item,
                                              sub_asset: {
                                                ...item.sub_asset,
                                                listing: [],
                                              },
                                            }
                                          : item,
                                      ),
                                    );
                                    setListingHelper((prev) =>
                                      prev.map((item, index) =>
                                        index === pIndex
                                          ? {
                                              ...item,
                                              contract: {
                                                ...item.contract,
                                                listing: [],
                                              },
                                            }
                                          : item,
                                      ),
                                    );
                                    setListingHelper((prev) =>
                                      prev.map((item, index) =>
                                        index === pIndex
                                          ? {
                                              ...item,
                                              receipt: {
                                                ...item.receipt,
                                                listing: [],
                                              },
                                            }
                                          : item,
                                      ),
                                    );
                                  }}
                                  name="asset_id"
                                  disabled={
                                    !values?.payments?.[pIndex]?.vendor_id ||
                                    listingHelper?.[pIndex]?.sub_asset?.loading
                                  }
                                  // disabled={true}
                                  initialValue={
                                    values?.payments?.[pIndex]?.asset_id
                                      ? values?.payments?.[pIndex]?.asset_id
                                      : ""
                                  }
                                  notUsingState={true}
                                  setAssetList={false}
                                  setListingHelper={setListingHelper}
                                  targetIndex={pIndex}
                                  setAssetLoading={(e) =>
                                    setListingHelper((prev) =>
                                      prev.map((item, index) =>
                                        index === pIndex
                                          ? {
                                              ...item,
                                              asset: {
                                                ...item.asset,
                                                loading: e,
                                              },
                                            }
                                          : item,
                                      ),
                                    )
                                  }
                                  onClear={() => {
                                    setFieldValue(
                                      `payments.${pIndex}.asset_id`,
                                      "",
                                    );
                                    setFieldValue(
                                      `payments.${pIndex}.sub_asset_id`,
                                      "",
                                    );
                                    setFieldValue(
                                      `payments.${pIndex}.contract_id`,
                                      "",
                                    );
                                    setFieldValue(
                                      `payments.${pIndex}.receipt_id`,
                                      "",
                                    );
                                    setListingHelper((prev) =>
                                      prev.map((item, index) =>
                                        index === pIndex
                                          ? {
                                              ...item,
                                              sub_asset: {
                                                ...item.sub_asset,
                                                listing: [],
                                              },
                                            }
                                          : item,
                                      ),
                                    );
                                    setListingHelper((prev) =>
                                      prev.map((item, index) =>
                                        index === pIndex
                                          ? {
                                              ...item,
                                              contract: {
                                                ...item.contract,
                                                listing: [],
                                              },
                                            }
                                          : item,
                                      ),
                                    );
                                    setListingHelper((prev) =>
                                      prev.map((item, index) =>
                                        index === pIndex
                                          ? {
                                              ...item,
                                              receipt: {
                                                ...item.receipt,
                                                listing: [],
                                              },
                                            }
                                          : item,
                                      ),
                                    );
                                  }}
                                  className={
                                    errors?.payments?.[pIndex]?.asset_id &&
                                    `focus-visible:ring-red-500 border-red-500`
                                  }
                                  loading={
                                    listingHelper?.[pIndex]?.asset?.loading
                                  }
                                />
                                {listingHelper?.[pIndex]?.asset?.loading && (
                                  <span className="absolute top-2 right-2 animate-spin">
                                    <Loader2 width={20} height={20} />
                                  </span>
                                )}
                              </div>
                            </div>
                          </div>

                          <div className="grid gap-2">
                            <div className="min-w-0">
                              <Label htmlFor="asset_id">
                                <CustomLabelText
                                  required={true}
                                  labelText={getModuleNamingBySlug(
                                    organizationData?.organizationData,
                                    "sub-assets",
                                    "Sub Asset",
                                  )}
                                  errorField={
                                    errors?.payments?.[pIndex]?.sub_asset_id
                                  }
                                />
                              </Label>
                              <div className="relative mt-2">
                                <SubAssetSelect
                                  trustId={trustId}
                                  assetId={
                                    values?.payments?.[pIndex]?.asset_id
                                      ? values?.payments?.[pIndex]?.asset_id
                                      : ""
                                  }
                                  payee={values?.payee === "contact" ? 2 : 1}
                                  editItem={editItem}
                                  payment_id={id}
                                  frameworkData={
                                    listingHelper[pIndex]?.sub_asset?.listing
                                      ? listingHelper[pIndex]?.sub_asset
                                          ?.listing
                                      : []
                                  } // List of vendors
                                  optionType={getModuleNamingBySlug(
                                    organizationData?.organizationData,
                                    "sub-assets",
                                    "Sub Asset",
                                  )}
                                  handleSelect={(e) => {
                                    let subAssetData = listingHelper[
                                      pIndex
                                    ]?.sub_asset?.listing?.find(
                                      (item) => item?.value === e,
                                    );
                                    setFieldValue(
                                      `payments.${pIndex}.tax_percentage`,
                                      subAssetData?.tax_percentage,
                                    );
                                    setFieldValue(
                                      `payments.${pIndex}.tax`,
                                      subAssetData?.tax_type,
                                    );

                                    setFieldValue(
                                      `payments.${pIndex}.sub_asset_id`,
                                      e,
                                    );
                                    setFieldValue(
                                      `payments.${pIndex}.contract_id`,
                                      "",
                                    );
                                    setFieldValue(
                                      `payments.${pIndex}.receipt_id`,
                                      subAssetData?.receipt_detail_ids,
                                    );

                                    let totalAmount =
                                      subAssetData?.receipt_details_total
                                        ? subAssetData?.receipt_details_total
                                        : "";

                                    let gst_price = CalculateGST(
                                      "1",
                                      values?.payments?.[pIndex]?.tax,
                                      totalAmount,
                                      subAssetData?.tax_percentage,
                                    );

                                    let amount_inc = CalculateAmountExcGST(
                                      "1",
                                      values?.payments?.[pIndex]?.tax,
                                      totalAmount,
                                      subAssetData?.tax_percentage,
                                    );

                                    let vendorData = vendorListing?.find(
                                      (item) =>
                                        item?.value ===
                                        values?.payments?.[pIndex]?.vendor_id,
                                    );

                                    let contactData = contactListing?.find(
                                      (item) =>
                                        item?.value ===
                                        values?.payments?.[pIndex]?.contact_id,
                                    );

                                    if (values?.payee === "contact") {
                                      initalContactAndTrustData({
                                        values,
                                        pIndex,
                                        contactData,
                                        setFieldValue,
                                      });
                                    } else {
                                      initalVendorAndTrustData({
                                        values,
                                        pIndex,
                                        vendorData,
                                        setFieldValue,
                                      });
                                    }

                                    values?.payments?.[pIndex]?.payment_data
                                      ?.length > 0 &&
                                      setFieldValue(
                                        `payments.${pIndex}.payment_data.${0}.total_amount`,
                                        totalAmount,
                                      );

                                    values?.payments?.[pIndex]?.payment_data
                                      ?.length > 0 &&
                                      setFieldValue(
                                        `payments.${pIndex}.payment_data.${0}.amount`,
                                        amount_inc,
                                      );

                                    values?.payments?.[pIndex]?.payment_data
                                      ?.length > 0 &&
                                      setFieldValue(
                                        `payments.${pIndex}.payment_data.${0}.tax_amount`,
                                        gst_price,
                                      );

                                    setListingHelper((prev) =>
                                      prev.map((item, index) =>
                                        index === pIndex
                                          ? {
                                              ...item,
                                              contract: {
                                                ...item.contract,
                                                listing: [],
                                              },
                                            }
                                          : item,
                                      ),
                                    );
                                    setListingHelper((prev) =>
                                      prev.map((item, index) =>
                                        index === pIndex
                                          ? {
                                              ...item,
                                              receipt: {
                                                ...item.receipt,
                                                listing: [],
                                              },
                                            }
                                          : item,
                                      ),
                                    );
                                  }}
                                  name="sub_asset_id"
                                  disabled={
                                    !values?.payments?.[pIndex]?.asset_id ||
                                    listingHelper[pIndex]?.receipt?.loading
                                  }
                                  initialValue={
                                    values?.payments?.[pIndex]?.sub_asset_id
                                      ? values?.payments?.[pIndex]?.sub_asset_id
                                      : ""
                                  }
                                  setListingHelper={setListingHelper}
                                  targetIndex={pIndex}
                                  setSubAssetList={false}
                                  setSubAssetLoading={(e) => {
                                    setListingHelper((prev) =>
                                      prev.map((item, index) =>
                                        index === pIndex
                                          ? {
                                              ...item,
                                              sub_asset: {
                                                ...item.sub_asset,
                                                loading: e,
                                              },
                                            }
                                          : item,
                                      ),
                                    );
                                  }} // Control loading state
                                  onClear={() => {
                                    setFieldValue(
                                      `payments.${pIndex}.sub_asset_id`,
                                      "",
                                    );
                                    setFieldValue(
                                      `payments.${pIndex}.tax_percentage`,
                                      "",
                                    );
                                    setFieldValue(`payments.${pIndex}.tax`, "");
                                    setFieldValue(
                                      `payments.${pIndex}.contract_id`,
                                      "",
                                    );
                                    setFieldValue(
                                      `payments.${pIndex}.receipt_id`,
                                      "",
                                    );
                                    setListingHelper((prev) =>
                                      prev.map((item, index) =>
                                        index === pIndex
                                          ? {
                                              ...item,
                                              contract: {
                                                ...item.contract,
                                                listing: [],
                                              },
                                            }
                                          : item,
                                      ),
                                    );
                                    setListingHelper((prev) =>
                                      prev.map((item, index) =>
                                        index === pIndex
                                          ? {
                                              ...item,
                                              receipt: {
                                                ...item.receipt,
                                                listing: [],
                                              },
                                            }
                                          : item,
                                      ),
                                    );
                                  }}
                                  className={
                                    errors?.payments?.[pIndex]?.sub_asset_id &&
                                    `focus-visible:ring-red-500 border-red-500`
                                  }
                                  loading={
                                    listingHelper?.[pIndex]?.sub_asset?.loading
                                  }
                                />
                                {listingHelper?.[pIndex]?.sub_asset
                                  ?.loading && (
                                  <span className="absolute top-2 right-2 animate-spin">
                                    <Loader2 width={20} height={20} />
                                  </span>
                                )}
                              </div>
                            </div>
                          </div>

                          <div className="grid gap-2">
                            <div className="min-w-0">
                              <Label htmlFor="contract_id">
                                <CustomLabelText
                                  labelText="Agreement/Contract"
                                  errorField={
                                    errors?.payments?.[pIndex]?.contract_id
                                  }
                                />
                              </Label>
                              <div className="relative mt-2">
                                <ContractSelect
                                  trustId={trustId}
                                  subAssetId={
                                    values?.payments?.[pIndex]?.sub_asset_id
                                      ? values?.payments?.[pIndex]?.sub_asset_id
                                      : ""
                                  }
                                  frameworkData={
                                    listingHelper[pIndex]?.contract?.listing
                                      ? listingHelper[pIndex]?.contract?.listing
                                      : []
                                  } // List of vendors
                                  optionType="Contract"
                                  handleSelect={(e) => {
                                    setFieldValue(
                                      `payments.${pIndex}.contract_id`,
                                      e,
                                    );
                                  }}
                                  name="contract_id"
                                  disabled={false}
                                  initialValue={
                                    values?.payments?.[pIndex]?.contract_id
                                      ? values?.payments?.[pIndex]?.contract_id
                                      : ""
                                  }
                                  setListingHelper={setListingHelper}
                                  targetIndex={pIndex}
                                  setContractList={false}
                                  setContractLoading={(e) => {
                                    setListingHelper((prev) =>
                                      prev.map((item, index) =>
                                        index === pIndex
                                          ? {
                                              ...item,
                                              contract: {
                                                ...item.contract,
                                                loading: e,
                                              },
                                            }
                                          : item,
                                      ),
                                    );
                                  }} // Control loading state
                                  onClear={() => {
                                    setFieldValue(
                                      `payments.${pIndex}.contract_id`,
                                      "",
                                    );
                                  }}
                                  className={
                                    errors?.payments?.[pIndex]?.contract_id &&
                                    `focus-visible:ring-red-500 border-red-500`
                                  }
                                  loading={
                                    listingHelper?.[pIndex]?.contract?.loading
                                  }
                                />
                                {listingHelper?.[pIndex]?.contract?.loading && (
                                  <span className="absolute top-2 right-2 animate-spin">
                                    <Loader2 width={20} height={20} />
                                  </span>
                                )}
                              </div>
                            </div>
                          </div>
                          <div className="grid gap-2">
                            <div className="min-w-0">
                              <Label htmlFor="contact_id">
                                <CustomLabelText
                                  labelText={getModuleNamingBySlug(
                                    organizationData?.organizationData,
                                    "contacts",
                                    "Customer",
                                  )}
                                  errorField={
                                    errors?.payments?.[pIndex]?.contact_id
                                  }
                                  required={
                                    values?.payee === "contact" ? true : false
                                  }
                                />
                              </Label>
                              <div className="relative mt-2">
                                <ContactSelect
                                  trustId={trustId}
                                  frameworkData={contactListing} // List of vendors
                                  optionType={getModuleNamingBySlug(
                                    organizationData?.organizationData,
                                    "contacts",
                                    "Customer",
                                  )}
                                  handleSelect={(e) => {
                                    let contactData = contactListing?.find(
                                      (item) => item?.value === e,
                                    );
                                    setFieldValue(
                                      `payments.${pIndex}.contact_id`,
                                      e,
                                    );

                                    if (values?.payee === "contact") {
                                      updateContactAndTrustData({
                                        values,
                                        pIndex,
                                        contactData,
                                        setFieldValue,
                                      });
                                    }

                                    // if (!contactData?.bank_id) {
                                    //   toast({
                                    //     variant: "primary",
                                    //     title: "Bank Details are missing",
                                    //     description: `To enter bank details of ${formatSubcontractorName(
                                    //       contactData,
                                    //     )}`,
                                    //     duration: 5000,
                                    //     action: (
                                    //       <ToastAction
                                    //         altText="Enter"
                                    //         className="hover:text-black"
                                    //         onClick={() => {
                                    //           navigate(
                                    //             `/trusts/${trustId}/contacts`,
                                    //             {
                                    //               state: {
                                    //                 contactId: e,
                                    //               },
                                    //             },
                                    //           );
                                    //         }}
                                    //       >
                                    //         Add
                                    //       </ToastAction>
                                    //     ),
                                    //   });
                                    // }
                                  }}
                                  name="contact_id"
                                  disabled={false}
                                  initialValue={
                                    values?.payments?.[pIndex]?.contact_id
                                      ? values?.payments?.[pIndex]?.contact_id
                                      : ""
                                  }
                                  setContactList={setContactList} // Update vendor list as new data loads
                                  setContactLoading={setContactLoading} // Control loading state
                                  onClear={() => {
                                    setFieldValue(
                                      `payments.${pIndex}.contact_id`,
                                      "",
                                    );
                                  }}
                                  className={
                                    errors?.payments?.[pIndex]?.contact_id &&
                                    `focus-visible:ring-red-500 border-red-500`
                                  }
                                  loading={contactLoading}
                                />
                                {contactLoading && (
                                  <span className="absolute top-2 right-2 animate-spin">
                                    <Loader2 width={20} height={20} />
                                  </span>
                                )}
                              </div>
                            </div>
                          </div>

                          {values?.payments?.[pIndex]?.sub_asset_id && (
                            // listingHelper[pIndex]?.sub_asset?.listing?.find(
                            //   (item) =>
                            //     item.value ===
                            //     values?.payments?.[pIndex]?.sub_asset_id
                            // )?.tax_type === "1" &&
                            <div className="grid gap-2">
                              <div className="min-w-0">
                                <Label htmlFor="gst">
                                  <CustomLabelText
                                    labelText="GST/VAT Applicable"
                                    errorField={errors?.payments?.[pIndex]?.tax}
                                    required={false}
                                  />
                                </Label>
                                <div className="relative mt-2">
                                  <SearchSelect
                                    frameworks={taxOptions}
                                    optionType={"GST Type"}
                                    handleSelect={(e) => {
                                      setFieldValue(
                                        `payments.${pIndex}.tax`,
                                        e,
                                      );

                                      let subAssetData = listingHelper[
                                        pIndex
                                      ]?.sub_asset?.listing?.find(
                                        (item) =>
                                          item?.value ===
                                          values?.payments?.[pIndex]
                                            ?.sub_asset_id,
                                      );

                                      let paymentListData =
                                        values?.payments?.[pIndex]
                                          ?.payment_data;

                                      for (
                                        let i = 0;
                                        i < paymentListData?.length;
                                        i++
                                      ) {
                                        let totalAmount = values?.payments?.[
                                          pIndex
                                        ]?.payment_data[i]?.total_amount
                                          ? values?.payments?.[pIndex]
                                              ?.payment_data[i]?.total_amount
                                          : "";

                                        let gst_price = CalculateGST(
                                          "1",
                                          e,
                                          totalAmount,
                                          subAssetData?.tax_percentage,
                                        );

                                        let amount_inc = CalculateAmountExcGST(
                                          "1",
                                          e,
                                          totalAmount,
                                          subAssetData?.tax_percentage,
                                        );

                                        setFieldValue(
                                          `payments.${pIndex}.payment_data.${i}.total_amount`,
                                          totalAmount,
                                        );

                                        setFieldValue(
                                          `payments.${pIndex}.payment_data.${i}.amount`,
                                          amount_inc,
                                        );

                                        setFieldValue(
                                          `payments.${pIndex}.payment_data.${i}.tax_amount`,
                                          gst_price,
                                        );
                                      }
                                    }}
                                    handleBlur={handleBlur}
                                    className={
                                      errors?.payments?.[pIndex]?.tax &&
                                      `focus-visible:ring-red-500 border-red-500`
                                    }
                                    disabled={false}
                                    initialValue={
                                      values?.payments?.[pIndex]?.tax
                                    }
                                  />
                                </div>
                              </div>
                            </div>
                          )}

                          {values?.payments?.[pIndex]?.sub_asset_id && (
                            <div className="grid gap-2">
                              <div className="min-w-0">
                                <Label htmlFor="receipt_id">
                                  <CustomLabelText
                                    labelText={
                                      <div className="flex items-center justify-between w-full">
                                        <div className="flex items-center gap-2">
                                          <p>Available Receipts</p>
                                          <CustomTooltip
                                            message={
                                              "Please Select the order in which you would like to disburse the payment"
                                            }
                                          >
                                            <InfoCircledIcon className="text-webPrimary" />
                                          </CustomTooltip>
                                        </div>
                                        {values?.payments?.[pIndex]?.receipt_id
                                          ?.length > 0 && (
                                          <div>
                                            Total:{" "}
                                            {formatNumber(
                                              ReceiptTotal(values, pIndex),
                                            )
                                              ? `$${formatNumber(
                                                  ReceiptTotal(values, pIndex),
                                                )}`
                                              : `$0.00`}
                                          </div>
                                        )}
                                      </div>
                                    }
                                  />
                                </Label>
                                <div className="relative mt-2">
                                  <ReceiptItemSelectMulti
                                    subAssetId={
                                      values?.payments?.[pIndex]?.sub_asset_id
                                        ? values?.payments?.[pIndex]
                                            ?.sub_asset_id
                                        : ""
                                    }
                                    subAssetData={listingHelper[
                                      pIndex
                                    ]?.sub_asset?.listing?.find(
                                      (item) =>
                                        item?.value ===
                                        values?.payments?.[pIndex]
                                          ?.sub_asset_id,
                                    )}
                                    payee={values?.payee === "contact" ? 2 : 1}
                                    editItem={editItem}
                                    payment_id={id}
                                    options={
                                      listingHelper[pIndex]?.receipt?.listing
                                    }
                                    placeholder={"Receipts Selected"}
                                    onValueChange={(e) => {
                                      setFieldValue(
                                        `payments.${pIndex}.receipt_id`,
                                        e,
                                      );

                                      let receiptlist = listingHelper[
                                        pIndex
                                      ]?.receipt?.listing?.filter(
                                        (item, index, self) =>
                                          index ===
                                          self.findIndex(
                                            (t) => t?.value === item?.value,
                                          ),
                                      );

                                      let receiptData = receiptlist?.filter(
                                        (item) => e.includes(item?.value),
                                      );

                                      let totalAmount = receiptData.reduce(
                                        (sum, item) =>
                                          sum + item?.remaining_balance,
                                        0,
                                      );

                                      let subAssetData = listingHelper[
                                        pIndex
                                      ]?.sub_asset?.listing?.find(
                                        (item) =>
                                          item?.value ===
                                          values?.payments?.[pIndex]
                                            ?.sub_asset_id,
                                      );

                                      let gst_price = CalculateGST(
                                        "1",
                                        values?.payments?.[pIndex]?.tax,
                                        totalAmount,
                                        subAssetData?.tax_percentage,
                                      );

                                      let amount_inc = CalculateAmountExcGST(
                                        "1",
                                        values?.payments?.[pIndex]?.tax,
                                        totalAmount,
                                        subAssetData?.tax_percentage,
                                      );

                                      values?.payments?.[pIndex]?.payment_data
                                        ?.length > 0 &&
                                        setFieldValue(
                                          `payments.${pIndex}.payment_data.${0}.total_amount`,
                                          totalAmount,
                                        );

                                      values?.payments?.[pIndex]?.payment_data
                                        ?.length > 0 &&
                                        setFieldValue(
                                          `payments.${pIndex}.payment_data.${0}.amount`,
                                          amount_inc,
                                        );

                                      values?.payments?.[pIndex]?.payment_data
                                        ?.length > 0 &&
                                        setFieldValue(
                                          `payments.${pIndex}.payment_data.${0}.tax_amount`,
                                          gst_price,
                                        );
                                    }}
                                    trustId={trustId}
                                    variant="inverted"
                                    animation={2}
                                    maxCount={0}
                                    setListingHelper={setListingHelper}
                                    targetIndex={pIndex}
                                    defaultValue={
                                      values?.payments?.[pIndex]?.receipt_id
                                        ? values?.payments?.[pIndex]?.receipt_id
                                        : ""
                                    }
                                    setReceiptItemList={false} // Update vendor list as new data loads
                                    setReceiptItemLoading={(e) => {
                                      setListingHelper((prev) =>
                                        prev.map((item, index) =>
                                          index === pIndex
                                            ? {
                                                ...item,
                                                receipt: {
                                                  ...item.receipt,
                                                  loading: e,
                                                },
                                              }
                                            : item,
                                        ),
                                      );
                                    }}
                                    className={
                                      errors?.payments?.[pIndex]?.receipt_id &&
                                      `focus-visible:ring-red-500 border-red-500`
                                    }
                                    loading={
                                      listingHelper?.[pIndex]?.receipt?.loading
                                    }
                                  />

                                  {listingHelper?.[pIndex]?.receipt
                                    ?.loading && (
                                    <span className="absolute top-2 right-2 animate-spin">
                                      <Loader2 width={20} height={20} />
                                    </span>
                                  )}
                                </div>
                              </div>
                            </div>
                          )}

                          {values?.payments?.[pIndex]?.sub_asset_id && (
                            <div className="grid gap-2">
                              <div className="min-w-0">
                                <Label htmlFor="history">
                                  <CustomLabelText labelText="History" />
                                </Label>
                                <div className="relative mt-2">
                                  <Button
                                    onClick={(e) => {
                                      e.preventDefault();
                                      toggleHistory(
                                        values?.payments?.[pIndex]
                                          ?.sub_asset_id,
                                      );
                                    }}
                                  >
                                    Receipt History
                                  </Button>
                                </div>
                              </div>
                            </div>
                          )}

                          {!LawyerConditon(organizationData) && (
                            <>
                              <div className="grid gap-2">
                                <div className="min-w-0">
                                  <Label htmlFor="ts_job_id">
                                    <CustomLabelText
                                      labelText="Job/Matter"
                                      errorField={
                                        errors?.payments?.[pIndex]?.ts_job_id
                                      }
                                    />
                                  </Label>
                                  <div className="relative mt-2">
                                    <JobSelect
                                      trustId={trustId}
                                      frameworkData={
                                        listingHelper[pIndex]?.job?.listing
                                          ? listingHelper[pIndex]?.job?.listing
                                          : []
                                      } // List of vendors
                                      optionType="Job/Matter"
                                      handleSelect={(e) => {
                                        setFieldValue(
                                          `payments.${pIndex}.ts_job_id`,
                                          e,
                                        );
                                        setListingHelper((prev) =>
                                          prev.map((item, index) =>
                                            index === 0
                                              ? {
                                                  ...item,
                                                  task: {
                                                    ...item.task,
                                                    listing: [],
                                                  },
                                                }
                                              : item,
                                          ),
                                        );
                                      }}
                                      name="ts_job_id"
                                      disabled={false}
                                      initialValue={
                                        values?.payments?.[pIndex]?.ts_job_id
                                          ? values?.payments?.[pIndex]
                                              ?.ts_job_id
                                          : ""
                                      }
                                      targetIndex={pIndex}
                                      setListingHelper={setListingHelper}
                                      setJobList={false} // Update vendor list as new data loads
                                      setJobLoading={(e) => {
                                        setListingHelper((prev) =>
                                          prev.map((item, index) =>
                                            index === pIndex
                                              ? {
                                                  ...item,
                                                  job: {
                                                    ...item.job,
                                                    loading: e,
                                                  },
                                                }
                                              : item,
                                          ),
                                        );
                                      }}
                                      onClear={() => {
                                        setFieldValue(
                                          `payments.${pIndex}.ts_job_id`,
                                          "",
                                        );

                                        setFieldValue(
                                          `payments.${pIndex}.ts_task_id`,
                                          "",
                                        );

                                        setListingHelper((prev) =>
                                          prev.map((item, index) =>
                                            index === 0
                                              ? {
                                                  ...item,
                                                  task: {
                                                    ...item.task,
                                                    listing: [],
                                                  },
                                                }
                                              : item,
                                          ),
                                        );
                                      }}
                                      className={
                                        errors?.payments?.[pIndex]?.ts_job_id &&
                                        `focus-visible:ring-red-500 border-red-500`
                                      }
                                      loading={
                                        listingHelper?.[pIndex]?.job?.loading
                                      }
                                    />
                                    {listingHelper?.[pIndex]?.job?.loading && (
                                      <span className="absolute top-2 right-2 animate-spin">
                                        <Loader2 width={20} height={20} />
                                      </span>
                                    )}
                                  </div>
                                </div>
                              </div>
                              <div className="grid gap-2">
                                <div className="min-w-0">
                                  <Label htmlFor="ts_task_id">
                                    <CustomLabelText
                                      labelText="Task/Milestone"
                                      errorField={
                                        errors?.payments?.[pIndex]?.ts_task_id
                                      }
                                    />
                                  </Label>
                                  <div className="relative mt-2">
                                    <TaskSelect
                                      trustId={trustId}
                                      jobId={
                                        values?.payments?.[pIndex]?.ts_job_id
                                          ? values?.payments?.[pIndex]
                                              ?.ts_job_id
                                          : ""
                                      }
                                      frameworkData={
                                        listingHelper?.[pIndex]?.task?.listing
                                          ? listingHelper?.[pIndex]?.task
                                              ?.listing
                                          : []
                                      } // List of vendors
                                      optionType="Task/Milestone"
                                      handleSelect={(e) => {
                                        setFieldValue(
                                          `payments.${pIndex}.ts_task_id`,
                                          e,
                                        );
                                      }}
                                      name="ts_task_id"
                                      disabled={
                                        !values?.payments?.[pIndex]?.ts_job_id
                                      }
                                      initialValue={
                                        values?.payments?.[pIndex]?.ts_task_id
                                          ? values?.payments?.[pIndex]
                                              ?.ts_task_id
                                          : ""
                                      }
                                      targetIndex={pIndex}
                                      setListingHelper={setListingHelper}
                                      setTaskList={false} // Update vendor list as new data loads
                                      setTaskLoading={(e) => {
                                        setListingHelper((prev) =>
                                          prev.map((item, index) =>
                                            index === pIndex
                                              ? {
                                                  ...item,
                                                  task: {
                                                    ...item.task,
                                                    loading: e,
                                                  },
                                                }
                                              : item,
                                          ),
                                        );
                                      }} // Control loading state
                                      onClear={() => {
                                        setFieldValue(
                                          `payments.${pIndex}.ts_task_id`,
                                          "",
                                        );
                                      }}
                                      className={
                                        errors?.payments?.[pIndex]
                                          ?.ts_task_id &&
                                        `focus-visible:ring-red-500 border-red-500`
                                      }
                                      loading={
                                        listingHelper?.[pIndex]?.task?.loading
                                      }
                                    />
                                    {listingHelper?.[pIndex]?.task?.loading && (
                                      <span className="absolute top-2 right-2 animate-spin">
                                        <Loader2 width={20} height={20} />
                                      </span>
                                    )}
                                  </div>
                                </div>
                              </div>{" "}
                            </>
                          )}

                          {/* <div className="grid lg:grid-cols-3 gap-4"> */}
                          {/* <div className="grid gap-2 col-span-2">
                              <div className="min-w-0">
                                <Label htmlFor="base_type">
                                  <CustomLabelText
                                    required={false}
                                    labelText="Joint Account"
                                    errorField={
                                      errors?.payments?.[pIndex]
                                        ?.joint_account_id
                                    }
                                  />
                                </Label>
                                <div className="relative mt-2">
                                  <SearchSelect
                                    frameworks={
                                      listingHelper?.[pIndex]?.joint_account
                                        ?.listing
                                        ? listingHelper?.[pIndex]?.joint_account
                                            ?.listing
                                        : []
                                    }
                                    optionType={"Joint Account"}
                                    handleSelect={(e) => {
                                      setFieldValue(
                                        `payments.${pIndex}.joint_account_id`,
                                        e
                                      );

                                      let jointAccountData = listingHelper?.[
                                        pIndex
                                      ]?.joint_account?.listing?.find(
                                        (itemData) => itemData?.value === e
                                      );

                                      let vendorData = vendorListing?.find(
                                        (item) =>
                                          item.value ===
                                          values?.payments?.[pIndex]?.vendor_id
                                      );

                                      updateVendorAndTrustData({
                                        values,
                                        pIndex,
                                        vendorData,
                                        setFieldValue,
                                        jointAccountData,
                                      });
                                    }}
                                    handleBlur={handleBlur}
                                    className={
                                      errors?.payments?.[pIndex]
                                        ?.joint_account_id &&
                                      `focus-visible:ring-red-500 border-red-500`
                                    }
                                    disabled={false}
                                    clearable={true}
                                    onClear={() => {
                                      setFieldValue(
                                        `payments.${pIndex}.joint_account_id`,
                                        ""
                                      );
                                    }}
                                    initialValue={
                                      values?.payments?.[pIndex]
                                        ?.joint_account_id
                                    }
                                  />
                                </div>
                              </div>
                            </div> */}
                          <div className="grid gap-2">
                            <div className="min-w-0">
                              <Label htmlFor="base_type">
                                <CustomLabelText
                                  required={false}
                                  labelText="Payment Method"
                                  errorField={
                                    errors?.payments?.[pIndex]?.payment_method
                                  }
                                />
                              </Label>
                              <div className="relative mt-2">
                                <SearchSelect
                                  frameworks={paymentMethods}
                                  optionType={"Payment Method"}
                                  handleSelect={(e) => {
                                    setFieldValue(
                                      `payments.${pIndex}.payment_method`,
                                      e,
                                    );
                                  }}
                                  handleBlur={handleBlur}
                                  className={
                                    errors?.payments?.[pIndex]
                                      ?.payment_method &&
                                    `focus-visible:ring-red-500 border-red-500`
                                  }
                                  disabled={false}
                                  clearable={true}
                                  onClear={() => {
                                    setFieldValue(
                                      `payments.${pIndex}.payment_method`,
                                      "",
                                    );
                                  }}
                                  initialValue={
                                    values?.payments?.[pIndex]?.payment_method
                                  }
                                />
                              </div>
                            </div>
                          </div>
                          {/* </div> */}
                        </div>

                        {/* Nested FieldArray: payment_data */}
                        <FieldArray name={`payments.${pIndex}.payment_data`}>
                          {({ push: pushData, remove: removeData }) => (
                            <>
                              <div className="flex items-center justify-between mt-4">
                                <h5 className="font-medium text-sm">
                                  Payment Rows
                                </h5>
                                <div className="flex items-center gap-1">
                                  {/* <AddSupplierBeneficaryPayment
                                    values={values}
                                    pIndex={pIndex}
                                    setFieldValue={setFieldValue}
                                    supplier={true}
                                  /> */}
                                  {values?.payee === "vendor" && (
                                    <Button
                                      type="button"
                                      variant="secondary"
                                      size="sm"
                                      onClick={() => {
                                        // setFieldValue(
                                        //   `payments.${pIndex}.payment_data`,
                                        //   values?.payments?.[
                                        //     pIndex
                                        //   ]?.payment_data?.filter(
                                        //     (item) => item?.supplier === true
                                        //   )
                                        // );

                                        values?.payments?.[
                                          pIndex
                                        ]?.payment_data?.filter(
                                          (item) => item?.supplier === true,
                                        )?.length === 0 &&
                                          setFieldValue(
                                            `payments.${pIndex}.tax`,
                                            "1",
                                          );
                                        pushData({
                                          contact_id: "",
                                          contact_name: "",
                                          from: "",
                                          to: "",
                                          total_amount: "",
                                          amount: "",
                                          tax_amount: "",
                                          bsb: "",
                                          account_name: "",
                                          account_number: "",
                                          supplier: true,
                                        });
                                      }}
                                    >
                                      <Plus className="w-4 h-4 mr-1" />
                                      Add Supplier
                                    </Button>
                                  )}
                                  {values?.payments?.[pIndex]?.vendor_id &&
                                    values?.payee === "vendor" && (
                                      <Button
                                        type="button"
                                        variant="secondary"
                                        size="sm"
                                        onClick={() =>
                                          pushData({
                                            contact_id: "",
                                            contact_name: "",
                                            from: "",
                                            to: "",
                                            tax_amount: "",
                                            amount: "",
                                            total_amount: "",
                                            bsb: "",
                                            account_name: "",
                                            account_number: "",
                                            beneficiary: true,
                                          })
                                        }
                                      >
                                        <Plus className="w-4 h-4 mr-1" />
                                        Add Beneficiary
                                      </Button>
                                    )}
                                  {values?.payments?.[pIndex]?.vendor_id &&
                                    !values?.payments?.[
                                      pIndex
                                    ]?.payment_data?.some(
                                      (item) => item.trust,
                                    ) && (
                                      <Button
                                        type="button"
                                        variant="secondary"
                                        size="sm"
                                        onClick={() => {
                                          const trustData = {
                                            contact_id: trustContextData?.id,
                                            contact_name:
                                              formatSubcontractorName(
                                                trustContextData,
                                              ),
                                            from: "",
                                            to: "",
                                            total_amount: "",
                                            amount: "",
                                            tax_amount: "",
                                            bsb: trustContextData
                                              ?.withdrawal_account?.bsb,
                                            account_name:
                                              trustContextData
                                                ?.withdrawal_account
                                                ?.account_name,
                                            account_number:
                                              trustContextData
                                                ?.withdrawal_account
                                                ?.account_number,
                                            description: "Professional Fees",
                                            trust: true,
                                          };
                                          const trustExists =
                                            values?.payments?.[
                                              pIndex
                                            ]?.payment_data?.some(
                                              (item) => item.trust,
                                            );
                                          if (!trustExists) {
                                            setFieldValue(
                                              `payments.${pIndex}.payment_data`,
                                              [
                                                ...values?.payments?.[pIndex]
                                                  ?.payment_data,
                                                trustData,
                                              ],
                                            );
                                          }
                                        }}
                                      >
                                        <Plus className="w-4 h-4 mr-1" />
                                        Add Fee
                                      </Button>
                                    )}

                                  {values?.payee === "contact"
                                    ? values?.payments?.[pIndex]?.contact_id &&
                                      !values?.payments?.[
                                        pIndex
                                      ]?.payment_data?.some(
                                        (item) => item?.contact,
                                      ) && (
                                        <Button
                                          type="button"
                                          variant="secondary"
                                          size="sm"
                                          onClick={() => {
                                            let contactData =
                                              contactListing?.find(
                                                (item) =>
                                                  item?.value ===
                                                  values?.payments?.[pIndex]
                                                    ?.contact_id,
                                              );
                                            initalContactAndTrustData({
                                              values,
                                              pIndex,
                                              contactData,
                                              setFieldValue,
                                            });
                                          }}
                                        >
                                          <Plus className="w-4 h-4 mr-1" />
                                          Add{" "}
                                          {getModuleNamingBySlug(
                                            organizationData?.organizationData,
                                            "contacts",
                                            "Customer",
                                          )}
                                        </Button>
                                      )
                                    : values?.payments?.[pIndex]?.vendor_id &&
                                      !values?.payments?.[
                                        pIndex
                                      ]?.payment_data?.some(
                                        (item) => item?.vendor,
                                      ) && (
                                        <Button
                                          type="button"
                                          variant="secondary"
                                          size="sm"
                                          onClick={() => {
                                            let vendorData =
                                              vendorListing?.find(
                                                (item) =>
                                                  item?.value ===
                                                  values?.payments?.[pIndex]
                                                    ?.vendor_id,
                                              );
                                            initalVendorAndTrustData({
                                              values,
                                              pIndex,
                                              vendorData,
                                              setFieldValue,
                                            });
                                          }}
                                        >
                                          <Plus className="w-4 h-4 mr-1" />
                                          Add{" "}
                                          {getModuleNamingBySlug(
                                            organizationData?.organizationData,
                                            "vendors",
                                            "Vendor",
                                          )}
                                        </Button>
                                      )}
                                </div>
                              </div>

                              {payment?.payment_data?.length > 0 &&
                                payment?.payment_data?.map((data, dIndex) => (
                                  <div className="relative">
                                    {!isDesktop && dIndex !== 0 && (
                                      <hr className="mt-4 border-webPrimary" />
                                    )}
                                    <div
                                      key={dIndex}
                                      className="grid lg:grid-cols-11 sm:grid-cols-2 grid-cols-1 gap-4 items-start !mt-4"
                                    >
                                      <div className="grid gap-2">
                                        <div className="min-w-0">
                                          {isDesktop ? (
                                            dIndex === 0 && (
                                              <Label>
                                                <CustomLabelText
                                                  required={false}
                                                  labelText="Payee"
                                                  errorField={
                                                    errors?.payments?.[pIndex]
                                                      ?.payment_data?.[dIndex]
                                                      ?.contact_id
                                                  }
                                                  className={"mb-2"}
                                                />
                                              </Label>
                                            )
                                          ) : (
                                            <Label>
                                              <CustomLabelText
                                                required={false}
                                                labelText="Payee"
                                                errorField={
                                                  errors?.payments?.[pIndex]
                                                    ?.payment_data?.[dIndex]
                                                    ?.contact_id
                                                }
                                                className={"mb-2"}
                                              />
                                            </Label>
                                          )}

                                          {data?.supplier ? (
                                            <div className="relative">
                                              <SupplierSelect
                                                trustId={trustId}
                                                frameworkData={supplierListing} // List of vendors
                                                optionType="Supplier"
                                                handleSelect={(e) => {
                                                  let supplierData =
                                                    supplierListing?.find(
                                                      (item) =>
                                                        item?.value === e,
                                                    );
                                                  setFieldValue(
                                                    `payments.${pIndex}.payment_data.${dIndex}.contact_id`,
                                                    e,
                                                  );

                                                  setFieldValue(
                                                    `payments.${pIndex}.payment_data.${dIndex}.bsb`,
                                                    supplierData?.bsb,
                                                  );
                                                  setFieldValue(
                                                    `payments.${pIndex}.payment_data.${dIndex}.account_name`,
                                                    supplierData?.account_name,
                                                  );
                                                  setFieldValue(
                                                    `payments.${pIndex}.payment_data.${dIndex}.account_number`,
                                                    supplierData?.account_number,
                                                  );

                                                  // updateSupplierAndTrustData({
                                                  //   values,
                                                  //   pIndex,
                                                  //   supplierData,
                                                  //   setFieldValue,
                                                  // });
                                                }}
                                                name="contact_id"
                                                disabled={false}
                                                initialValue={
                                                  values?.payments?.[pIndex]
                                                    ?.payment_data?.[dIndex]
                                                    ?.contact_id
                                                    ? values?.payments?.[pIndex]
                                                        ?.payment_data?.[dIndex]
                                                        ?.contact_id
                                                    : ""
                                                }
                                                setSupplierList={
                                                  setSupplierList
                                                } // Update vendor list as new data loads
                                                setSupplierLoading={
                                                  setSupplierLoading
                                                } // Control loading state
                                                onClear={() => {
                                                  setFieldValue(
                                                    `payments.${pIndex}.payment_data.${dIndex}.contact_id`,
                                                    "",
                                                  );
                                                  setFieldValue(
                                                    `payments.${pIndex}.payment_data.${dIndex}.bsb`,
                                                    "",
                                                  );
                                                  setFieldValue(
                                                    `payments.${pIndex}.payment_data.${dIndex}.account_name`,
                                                    "",
                                                  );
                                                  setFieldValue(
                                                    `payments.${pIndex}.payment_data.${dIndex}.account_number`,
                                                    "",
                                                  );
                                                }}
                                                className={
                                                  errors?.payments?.[pIndex]
                                                    ?.payment_data?.[dIndex]
                                                    ?.contact_id &&
                                                  `focus-visible:ring-red-500 border-red-500`
                                                }
                                                loading={supplierLoading}
                                              />
                                              {supplierLoading && (
                                                <span className="absolute top-2 right-2 animate-spin">
                                                  <Loader2
                                                    width={20}
                                                    height={20}
                                                  />
                                                </span>
                                              )}
                                            </div>
                                          ) : data?.beneficiary ? (
                                            <div className="relative">
                                              <BeneficarySelect
                                                trustId={trustId}
                                                vendorId={
                                                  values?.payments?.[pIndex]
                                                    ?.vendor_id
                                                    ? values?.payments?.[pIndex]
                                                        ?.vendor_id
                                                    : ""
                                                }
                                                frameworkData={
                                                  listingHelper?.[pIndex]
                                                    ?.beneficiary?.listing
                                                    ? listingHelper?.[pIndex]
                                                        ?.beneficiary?.listing
                                                    : []
                                                }
                                                optionType="Beneficiary"
                                                handleSelect={(e) => {
                                                  setFieldValue(
                                                    `payments.${pIndex}.payment_data.${dIndex}.contact_id`,
                                                    e,
                                                  );
                                                  let beneficiaryData =
                                                    listingHelper?.[
                                                      pIndex
                                                    ]?.beneficiary?.listing?.find(
                                                      (item) =>
                                                        item?.value === e,
                                                    );

                                                  setFieldValue(
                                                    `payments.${pIndex}.payment_data.${dIndex}.bsb`,
                                                    beneficiaryData?.bsb,
                                                  );
                                                  setFieldValue(
                                                    `payments.${pIndex}.payment_data.${dIndex}.account_name`,
                                                    beneficiaryData?.account_name,
                                                  );
                                                  setFieldValue(
                                                    `payments.${pIndex}.payment_data.${dIndex}.account_number`,
                                                    beneficiaryData?.account_number,
                                                  );
                                                }}
                                                name="contact_id"
                                                disabled={false}
                                                initialValue={
                                                  values?.payments?.[pIndex]
                                                    ?.payment_data?.[dIndex]
                                                    ?.contact_id
                                                    ? values?.payments?.[pIndex]
                                                        ?.payment_data?.[dIndex]
                                                        ?.contact_id
                                                    : ""
                                                }
                                                notUsingState={true}
                                                setBeneficaryList={false}
                                                setListingHelper={
                                                  setListingHelper
                                                }
                                                targetIndex={pIndex}
                                                setBeneficaryLoading={(e) =>
                                                  setListingHelper((prev) =>
                                                    prev.map((item, index) =>
                                                      index === pIndex
                                                        ? {
                                                            ...item,
                                                            beneficiary: {
                                                              ...item.beneficiary,
                                                              loading: e,
                                                            },
                                                          }
                                                        : item,
                                                    ),
                                                  )
                                                }
                                                onClear={() => {
                                                  setFieldValue(
                                                    `payments.${pIndex}.payment_data.${dIndex}.contact_id`,
                                                    "",
                                                  );
                                                  setFieldValue(
                                                    `payments.${pIndex}.payment_data.${dIndex}.bsb`,
                                                    "",
                                                  );
                                                  setFieldValue(
                                                    `payments.${pIndex}.payment_data.${dIndex}.account_name`,
                                                    "",
                                                  );
                                                  setFieldValue(
                                                    `payments.${pIndex}.payment_data.${dIndex}.account_number`,
                                                    "",
                                                  );
                                                }}
                                                className={
                                                  errors?.payments?.[pIndex]
                                                    ?.payment_data?.[dIndex]
                                                    ?.contact_id &&
                                                  `focus-visible:ring-red-500 border-red-500`
                                                }
                                                loading={
                                                  listingHelper?.[pIndex]
                                                    ?.beneficiary?.loading
                                                }
                                              />
                                              {listingHelper?.[pIndex]
                                                ?.beneficiary?.loading && (
                                                <span className="absolute top-2 right-2 animate-spin">
                                                  <Loader2
                                                    width={20}
                                                    height={20}
                                                  />
                                                </span>
                                              )}
                                            </div>
                                          ) : (
                                            <Input
                                              id={`payments.${pIndex}.payment_data.${dIndex}.contact_name`}
                                              type="text"
                                              name={`payments.${pIndex}.payment_data.${dIndex}.contact_name`}
                                              value={
                                                values?.payments?.[pIndex]
                                                  ?.payment_data?.[dIndex]
                                                  ?.contact_name
                                                  ? values?.payments?.[pIndex]
                                                      ?.payment_data?.[dIndex]
                                                      ?.contact_name
                                                  : ""
                                              }
                                              disabled={true}
                                              placeholder={
                                                values?.payments?.[pIndex]
                                                  ?.payment_data?.[dIndex]
                                                  ?.supplier
                                                  ? "Supplier"
                                                  : values?.payments?.[pIndex]
                                                        ?.payment_data?.[dIndex]
                                                        ?.beneficiary
                                                    ? "Beneficiary"
                                                    : "Contact"
                                              }
                                              onChange={handleChange}
                                              onBlur={handleBlur}
                                              autoComplete="off"
                                              onKeyPress={(e) => {
                                                e.which === 13 &&
                                                  e.preventDefault();
                                              }}
                                              className={
                                                errors?.payments?.[pIndex]
                                                  ?.payment_data?.[dIndex]
                                                  ?.contact_name &&
                                                `focus-visible:ring-red-500 border-red-500`
                                              }
                                            />
                                          )}
                                        </div>
                                      </div>
                                      <div className="grid gap-2">
                                        {isDesktop ? (
                                          dIndex === 0 && (
                                            <Label>
                                              <CustomLabelText
                                                required={false}
                                                labelText="From"
                                                errorField={
                                                  errors?.payments?.[pIndex]
                                                    ?.payment_data?.[dIndex]
                                                    ?.from
                                                }
                                              />
                                            </Label>
                                          )
                                        ) : (
                                          <Label>
                                            <CustomLabelText
                                              required={false}
                                              labelText="From"
                                              errorField={
                                                errors?.payments?.[pIndex]
                                                  ?.payment_data?.[dIndex]?.from
                                              }
                                            />
                                          </Label>
                                        )}
                                        <DateInputPicker
                                          date={
                                            values?.payments?.[pIndex]
                                              ?.payment_data?.[dIndex]?.from
                                              ? values?.payments?.[pIndex]
                                                  ?.payment_data?.[dIndex]?.from
                                              : ""
                                          }
                                          onSelect={(e) => {
                                            setFieldValue(
                                              `payments.${pIndex}.payment_data.${dIndex}.from`,
                                              e,
                                            );
                                          }}
                                          className={""}
                                          inputClassName={"w-full"}
                                          icon={false}
                                          disabledDate={{ after: new Date() }}
                                        />
                                      </div>
                                      <div className="grid gap-2">
                                        {isDesktop ? (
                                          dIndex === 0 && (
                                            <Label>
                                              <CustomLabelText
                                                required={false}
                                                labelText="To"
                                                errorField={
                                                  errors?.payments?.[pIndex]
                                                    ?.payment_data?.[dIndex]?.to
                                                }
                                              />
                                            </Label>
                                          )
                                        ) : (
                                          <Label>
                                            <CustomLabelText
                                              required={false}
                                              labelText="To"
                                              errorField={
                                                errors?.payments?.[pIndex]
                                                  ?.payment_data?.[dIndex]?.to
                                              }
                                            />
                                          </Label>
                                        )}
                                        <DateInputPicker
                                          date={
                                            values?.payments?.[pIndex]
                                              ?.payment_data?.[dIndex]?.to
                                              ? values?.payments?.[pIndex]
                                                  ?.payment_data?.[dIndex]?.to
                                              : ""
                                          }
                                          onSelect={(e) => {
                                            setFieldValue(
                                              `payments.${pIndex}.payment_data.${dIndex}.to`,
                                              e,
                                            );
                                          }}
                                          className={""}
                                          inputClassName={"w-full"}
                                          icon={false}
                                        />
                                      </div>

                                      <div className="grid gap-2">
                                        {isDesktop ? (
                                          dIndex === 0 && (
                                            <Label>
                                              <CustomLabelText
                                                required={false}
                                                labelText={
                                                  CheckTotal(values, pIndex) ? (
                                                    "Amount (Inc)"
                                                  ) : (
                                                    <div className="flex items-center gap-2">
                                                      Amount (Inc)
                                                      <CustomTooltip
                                                        message={
                                                          "Available Receipts for Disbursement can not be less than payment amount"
                                                        }
                                                      >
                                                        <InfoCircledIcon className="text-red-500" />
                                                      </CustomTooltip>
                                                    </div>
                                                  )
                                                }
                                                errorField={
                                                  errors?.payments?.[pIndex]
                                                    ?.payment_data?.[dIndex]
                                                    ?.total_amount
                                                }
                                              />
                                            </Label>
                                          )
                                        ) : (
                                          <Label>
                                            <CustomLabelText
                                              required={false}
                                              labelText={
                                                CheckTotal(values, pIndex) ? (
                                                  "Amount (Inc)"
                                                ) : (
                                                  <div className="flex items-center gap-2">
                                                    Amount (Inc)
                                                    <CustomTooltip
                                                      message={
                                                        "Available Receipts for Disbursement can not be less than payment amount"
                                                      }
                                                    >
                                                      <InfoCircledIcon className="text-red-500" />
                                                    </CustomTooltip>
                                                  </div>
                                                )
                                              }
                                              errorField={
                                                errors?.payments?.[pIndex]
                                                  ?.payment_data?.[dIndex]
                                                  ?.total_amount
                                              }
                                            />
                                          </Label>
                                        )}
                                        <Input
                                          id={`payments.${pIndex}.payment_data.${dIndex}.total_amount`}
                                          type="number"
                                          name={`payments.${pIndex}.payment_data.${dIndex}.total_amount`}
                                          value={
                                            values?.payments?.[pIndex]
                                              ?.payment_data?.[dIndex]
                                              ?.total_amount
                                              ? values?.payments?.[pIndex]
                                                  ?.payment_data?.[dIndex]
                                                  ?.total_amount
                                              : ""
                                          }
                                          placeholder="Total Amount"
                                          onChange={(e) => {
                                            setFieldValue(
                                              `payments.${pIndex}.payment_data.${dIndex}.total_amount`,
                                              e?.target.value,
                                            );

                                            let totalAmount = e?.target.value
                                              ? e?.target.value
                                              : 0;

                                            let subAssetData = listingHelper[
                                              pIndex
                                            ]?.sub_asset?.listing?.find(
                                              (item) =>
                                                item?.value ===
                                                values?.payments?.[pIndex]
                                                  ?.sub_asset_id,
                                            );

                                            let gst_price = CalculateGST(
                                              "1",
                                              values?.payments?.[pIndex]?.tax,
                                              totalAmount,
                                              subAssetData?.tax_percentage,
                                            );

                                            let amount_inc =
                                              CalculateAmountExcGST(
                                                "1",
                                                values?.payments?.[pIndex]?.tax,
                                                totalAmount,
                                                subAssetData?.tax_percentage,
                                              );

                                            setFieldValue(
                                              `payments.${pIndex}.payment_data.${dIndex}.total_amount`,
                                              totalAmount,
                                            );

                                            setFieldValue(
                                              `payments.${pIndex}.payment_data.${dIndex}.amount`,
                                              amount_inc,
                                            );

                                            setFieldValue(
                                              `payments.${pIndex}.payment_data.${dIndex}.tax_amount`,
                                              gst_price,
                                            );
                                          }}
                                          onBlur={handleBlur}
                                          autoComplete="off"
                                          onKeyPress={(e) => {
                                            e.which === 13 &&
                                              e.preventDefault();
                                          }}
                                          onKeyDown={(e) => {
                                            // Block e, E, +, -
                                            if (
                                              ["e", "E", "+", "-"].includes(
                                                e.key,
                                              )
                                            ) {
                                              e.preventDefault();
                                            }
                                          }}
                                          onInput={(e) => {
                                            // Prevent negative numbers
                                            if (e.target.value < 0) {
                                              e.target.value = 0;
                                            }
                                          }}
                                          className={
                                            errors?.payments?.[pIndex]
                                              ?.payment_data?.[dIndex]
                                              ?.total_amount &&
                                            `focus-visible:ring-red-500 border-red-500`
                                          }
                                        />
                                      </div>

                                      <div className="grid gap-2">
                                        {isDesktop ? (
                                          dIndex === 0 && (
                                            <Label>
                                              <CustomLabelText
                                                required={false}
                                                labelText="Amount (Exc)"
                                                errorField={
                                                  errors?.payments?.[pIndex]
                                                    ?.payment_data?.[dIndex]
                                                    ?.amount
                                                }
                                              />
                                            </Label>
                                          )
                                        ) : (
                                          <Label>
                                            <CustomLabelText
                                              required={false}
                                              labelText="Amount (Exc)"
                                              errorField={
                                                errors?.payments?.[pIndex]
                                                  ?.payment_data?.[dIndex]
                                                  ?.amount
                                              }
                                            />
                                          </Label>
                                        )}
                                        <Input
                                          id={`payments.${pIndex}.payment_data.${dIndex}.amount`}
                                          type="text"
                                          name={`payments.${pIndex}.payment_data.${dIndex}.amount`}
                                          value={
                                            values?.payments?.[pIndex]
                                              ?.payment_data?.[dIndex]?.amount
                                              ? values?.payments?.[pIndex]
                                                  ?.payment_data?.[dIndex]
                                                  ?.amount
                                              : ""
                                          }
                                          placeholder="Amount"
                                          onChange={(e) => {
                                            setFieldValue(
                                              `payments.${pIndex}.payment_data.${dIndex}.amount`,
                                              e?.target.value,
                                            );
                                          }}
                                          onBlur={handleBlur}
                                          autoComplete="off"
                                          onKeyPress={(e) => {
                                            e.which === 13 &&
                                              e.preventDefault();
                                          }}
                                          disabled
                                          className={
                                            errors?.payments?.[pIndex]
                                              ?.payment_data?.[dIndex]
                                              ?.amount &&
                                            `focus-visible:ring-red-500 border-red-500`
                                          }
                                        />
                                      </div>

                                      <div className="grid gap-2">
                                        {isDesktop ? (
                                          dIndex === 0 && (
                                            <Label>
                                              <CustomLabelText
                                                required={false}
                                                // labelText={`Tax(${
                                                //   values?.payments?.[pIndex]
                                                //     ?.tax === "1"
                                                //     ? values?.payments?.[pIndex]
                                                //         ?.tax_percentage
                                                //       ? values?.payments?.[
                                                //           pIndex
                                                //         ]?.tax_percentage
                                                //       : 0
                                                //     : 0
                                                // }%)`}
                                                labelText={`Tax`}
                                                errorField={
                                                  errors?.payments?.[pIndex]
                                                    ?.payment_data?.[dIndex]
                                                    ?.tax_amount
                                                }
                                              />
                                            </Label>
                                          )
                                        ) : (
                                          <Label>
                                            <CustomLabelText
                                              required={false}
                                              // labelText={`Tax(${
                                              //   values?.payments?.[pIndex]
                                              //     ?.tax === "1"
                                              //     ? values?.payments?.[pIndex]
                                              //         ?.tax_percentage
                                              //       ? values?.payments?.[pIndex]
                                              //           ?.tax_percentage
                                              //       : 0
                                              //     : 0
                                              // }%)`}
                                              labelText={`Tax`}
                                              errorField={
                                                errors?.payments?.[pIndex]
                                                  ?.payment_data?.[dIndex]
                                                  ?.tax_amount
                                              }
                                            />
                                          </Label>
                                        )}
                                        <Input
                                          id={`payments.${pIndex}.payment_data.${dIndex}.tax_amount`}
                                          type="text"
                                          name={`payments.${pIndex}.payment_data.${dIndex}.tax_amount`}
                                          value={
                                            values?.payments?.[pIndex]
                                              ?.payment_data?.[dIndex]
                                              ?.tax_amount
                                              ? values?.payments?.[pIndex]
                                                  ?.payment_data?.[dIndex]
                                                  ?.tax_amount
                                              : "0"
                                          }
                                          placeholder="Tax Amount"
                                          onChange={(e) => {
                                            setFieldValue(
                                              `payments.${pIndex}.payment_data.${dIndex}.tax_amount`,
                                              e?.target.value,
                                            );
                                          }}
                                          onBlur={handleBlur}
                                          autoComplete="off"
                                          onKeyPress={(e) => {
                                            e.which === 13 &&
                                              e.preventDefault();
                                          }}
                                          disabled={true}
                                          className={
                                            errors?.payments?.[pIndex]
                                              ?.payment_data?.[dIndex]
                                              ?.tax_amount &&
                                            `focus-visible:ring-red-500 border-red-500`
                                          }
                                        />
                                      </div>

                                      <div className="grid gap-2">
                                        {isDesktop ? (
                                          dIndex === 0 && (
                                            <Label>
                                              <CustomLabelText
                                                required={false}
                                                labelText="Account Name"
                                                errorField={
                                                  errors?.payments?.[pIndex]
                                                    ?.payment_data?.[dIndex]
                                                    ?.account_name
                                                }
                                              />
                                            </Label>
                                          )
                                        ) : (
                                          <Label>
                                            <CustomLabelText
                                              required={false}
                                              labelText="Account Name"
                                              errorField={
                                                errors?.payments?.[pIndex]
                                                  ?.payment_data?.[dIndex]
                                                  ?.account_name
                                              }
                                            />
                                          </Label>
                                        )}
                                        <Input
                                          // id={`payments.${pIndex}.payment_data.${dIndex}.account_name`}
                                          type="text"
                                          name={`payments.${pIndex}.payment_data.${dIndex}.account_name`}
                                          value={
                                            values?.payments?.[pIndex]
                                              ?.payment_data?.[dIndex]
                                              ?.account_name
                                              ? values?.payments?.[pIndex]
                                                  ?.payment_data?.[dIndex]
                                                  ?.account_name
                                              : ""
                                          }
                                          onChange={(e) => {
                                            setFieldValue(
                                              `payments.${pIndex}.payment_data.${dIndex}.account_name`,
                                              e?.target.value,
                                            );
                                          }}
                                          onBlur={handleBlur}
                                          placeholder="Account Name"
                                          autoComplete="off"
                                          onKeyPress={(e) => {
                                            e.which === 13 &&
                                              e.preventDefault();
                                          }}
                                          className={
                                            errors?.payments?.[pIndex]
                                              ?.payment_data?.[dIndex]
                                              ?.account_name
                                              ? `${cn(
                                                  "flex h-9 w-full rounded-md border border-input bg-transparent px-3 py-1 text-sm shadow-sm transition-colors file:border-0 file:bg-transparent file:text-sm file:font-medium placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-webPrimary dark:focus-visible:ring-ring disabled:cursor-not-allowed disabled:opacity-50",
                                                )} focus-visible:ring-red-500 border-red-500`
                                              : cn(
                                                  "flex h-9 w-full rounded-md border border-input bg-transparent px-3 py-1 text-sm shadow-sm transition-colors file:border-0 file:bg-transparent file:text-sm file:font-medium placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-webPrimary dark:focus-visible:ring-ring disabled:cursor-not-allowed disabled:opacity-50",
                                                )
                                          }
                                        />
                                      </div>

                                      <div className="grid gap-2">
                                        {isDesktop ? (
                                          dIndex === 0 && (
                                            <Label>
                                              <CustomLabelText
                                                required={false}
                                                labelText="BSB"
                                                errorField={
                                                  errors?.payments?.[pIndex]
                                                    ?.payment_data?.[dIndex]
                                                    ?.bsb
                                                }
                                              />
                                            </Label>
                                          )
                                        ) : (
                                          <Label>
                                            <CustomLabelText
                                              required={false}
                                              labelText="BSB"
                                              errorField={
                                                errors?.payments?.[pIndex]
                                                  ?.payment_data?.[dIndex]?.bsb
                                              }
                                            />
                                          </Label>
                                        )}
                                        <ReactInputMask
                                          id={`payments.${pIndex}.payment_data.${dIndex}.bsb`}
                                          type="text"
                                          name={`payments.${pIndex}.payment_data.${dIndex}.bsb`}
                                          value={
                                            values?.payments?.[pIndex]
                                              ?.payment_data?.[dIndex]?.bsb
                                              ? values?.payments?.[pIndex]
                                                  ?.payment_data?.[dIndex]?.bsb
                                              : ""
                                          }
                                          onChange={(e) => {
                                            setFieldValue(
                                              `payments.${pIndex}.payment_data.${dIndex}.bsb`,
                                              e?.target.value,
                                            );
                                          }}
                                          onBlur={(e) => {
                                            let bsb = formatBSBNumber(
                                              e?.target.value,
                                            );
                                            setFieldValue(
                                              `payments.${pIndex}.payment_data.${dIndex}.bsb`,
                                              bsb,
                                            );
                                          }}
                                          placeholder="BSB"
                                          mask="999-999"
                                          maskChar={null}
                                          autoComplete="off"
                                          onKeyPress={(e) => {
                                            e.which === 13 &&
                                              e.preventDefault();
                                          }}
                                          className={
                                            errors?.payments?.[pIndex]
                                              ?.payment_data?.[dIndex]?.bsb
                                              ? `${cn(
                                                  "flex h-9 w-full rounded-md border border-input bg-transparent px-3 py-1 text-sm shadow-sm transition-colors file:border-0 file:bg-transparent file:text-sm file:font-medium placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-webPrimary dark:focus-visible:ring-ring disabled:cursor-not-allowed disabled:opacity-50",
                                                )} focus-visible:ring-red-500 border-red-500`
                                              : cn(
                                                  "flex h-9 w-full rounded-md border border-input bg-transparent px-3 py-1 text-sm shadow-sm transition-colors file:border-0 file:bg-transparent file:text-sm file:font-medium placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-webPrimary dark:focus-visible:ring-ring disabled:cursor-not-allowed disabled:opacity-50",
                                                )
                                          }
                                        />
                                      </div>
                                      <div className="grid gap-2">
                                        {isDesktop ? (
                                          dIndex === 0 && (
                                            <Label>
                                              <CustomLabelText
                                                required={false}
                                                labelText="Account Number"
                                                errorField={
                                                  errors?.payments?.[pIndex]
                                                    ?.payment_data?.[dIndex]
                                                    ?.account_number
                                                }
                                              />
                                            </Label>
                                          )
                                        ) : (
                                          <Label>
                                            <CustomLabelText
                                              required={false}
                                              labelText="Account Number"
                                              errorField={
                                                errors?.payments?.[pIndex]
                                                  ?.payment_data?.[dIndex]
                                                  ?.account_number
                                              }
                                            />
                                          </Label>
                                        )}
                                        <ReactInputMask
                                          id={`payments.${pIndex}.payment_data.${dIndex}.account_number`}
                                          type="text"
                                          name={`payments.${pIndex}.payment_data.${dIndex}.account_number`}
                                          value={
                                            values?.payments?.[pIndex]
                                              ?.payment_data?.[dIndex]
                                              ?.account_number
                                              ? values?.payments?.[pIndex]
                                                  ?.payment_data?.[dIndex]
                                                  ?.account_number
                                              : ""
                                          }
                                          placeholder="Account No."
                                          onChange={(e) => {
                                            setFieldValue(
                                              `payments.${pIndex}.payment_data.${dIndex}.account_number`,
                                              e?.target.value,
                                            );
                                          }}
                                          onBlur={handleBlur}
                                          mask="999999999"
                                          maskChar={null}
                                          autoComplete="off"
                                          onKeyPress={(e) => {
                                            e.which === 13 &&
                                              e.preventDefault();
                                          }}
                                          className={
                                            errors?.payments?.[pIndex]
                                              ?.payment_data?.[dIndex]
                                              ?.account_number
                                              ? `${cn(
                                                  "flex h-9 w-full rounded-md border border-input bg-transparent px-3 py-1 text-sm shadow-sm transition-colors file:border-0 file:bg-transparent file:text-sm file:font-medium placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-webPrimary dark:focus-visible:ring-ring disabled:cursor-not-allowed disabled:opacity-50",
                                                )} focus-visible:ring-red-500 border-red-500`
                                              : cn(
                                                  "flex h-9 w-full rounded-md border border-input bg-transparent px-3 py-1 text-sm shadow-sm transition-colors file:border-0 file:bg-transparent file:text-sm file:font-medium placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-webPrimary dark:focus-visible:ring-ring disabled:cursor-not-allowed disabled:opacity-50",
                                                )
                                          }
                                        />
                                      </div>

                                      <div className="flex gap-2 sm:col-span-2">
                                        <div className="grid gap-2 flex-1">
                                          {isDesktop ? (
                                            dIndex === 0 && (
                                              <Label>
                                                <CustomLabelText
                                                  required={false}
                                                  // labelText="Description"
                                                  labelText={
                                                    LawyerConditon(
                                                      organizationData,
                                                    )
                                                      ? "Matter Description"
                                                      : "Description"
                                                  }
                                                  errorField={
                                                    errors?.payments?.[pIndex]
                                                      ?.payment_data?.[dIndex]
                                                      ?.description
                                                  }
                                                />
                                              </Label>
                                            )
                                          ) : (
                                            <Label>
                                              <CustomLabelText
                                                required={false}
                                                // labelText="Description"
                                                labelText={
                                                  LawyerConditon(
                                                    organizationData,
                                                  )
                                                    ? "Matter Description"
                                                    : "Description"
                                                }
                                                errorField={
                                                  errors?.payments?.[pIndex]
                                                    ?.payment_data?.[dIndex]
                                                    ?.description
                                                }
                                              />
                                            </Label>
                                          )}
                                          <Textarea
                                            id={`payments.${pIndex}.payment_data.${dIndex}.description`}
                                            name={`payments.${pIndex}.payment_data.${dIndex}.description`}
                                            value={
                                              values?.payments?.[pIndex]
                                                ?.payment_data?.[dIndex]
                                                ?.description
                                                ? values?.payments?.[pIndex]
                                                    ?.payment_data?.[dIndex]
                                                    ?.description
                                                : ""
                                            }
                                            // placeholder={"Description"}
                                            placeholder={
                                              LawyerConditon(organizationData)
                                                ? "Matter Description"
                                                : "Description"
                                            }
                                            onChange={(e) => {
                                              setFieldValue(
                                                `payments.${pIndex}.payment_data.${dIndex}.description`,
                                                e?.target.value,
                                              );
                                            }}
                                            onBlur={handleBlur}
                                            autoComplete="off"
                                            onKeyPress={(e) => {
                                              e.which === 13 &&
                                                e.preventDefault();
                                            }}
                                            className={
                                              errors?.payments?.[pIndex]
                                                ?.payment_data?.[dIndex]
                                                ?.description &&
                                              `focus-visible:ring-red-500 border-red-500`
                                            }
                                          />
                                        </div>

                                        <Button
                                          type="button"
                                          variant="ghost"
                                          size="icon"
                                          onClick={() => removeData(dIndex)}
                                          className={`h-7 w-7 ${
                                            isDesktop
                                              ? dIndex === 0
                                                ? "mt-5"
                                                : ""
                                              : dIndex === 0
                                                ? "absolute top-1 right-1 -mt-4"
                                                : "absolute top-1 right-1"
                                          }`}
                                        >
                                          <Trash2 className="w-4 h-4 text-red-500" />
                                        </Button>
                                      </div>
                                    </div>
                                  </div>
                                ))}
                            </>
                          )}
                        </FieldArray>
                      </div>
                    ))}

                    {/* <div>
                      <Button
                        type="button"
                        onClick={() => {
                          push({
                            contact_id: "",
                            contract_id: "",
                            vendor_id: "",
                            asset_id: "",
                            sub_asset_id: "",
                            ts_job_id: "",
                            ts_task_id: "",
                            payment_data: [],
                          });

                          setListingHelper((pre) => [
                            ...pre,
                            {
                              asset: {
                                listing: [],
                                loading: false,
                              },
                              sub_asset: {
                                listing: [],
                                loading: false,
                              },
                              contract: {
                                listing: [],
                                loading: false,
                              },
                              beneficiary: {
                                listing: [],
                                loading: false,
                              },
                            },
                          ]);
                        }}
                      >
                        <Plus className="w-4 h-4 mr-1" />
                        Add Payment
                      </Button>
                    </div> */}
                  </>
                )}
              </FieldArray>
            </div>
            <div className="modal-footer pt-4 border-t mt-4 flex items-center justify-end">
              <Button type="submit" disabled={!CheckTotal(values) || !isValid}>
                Post
              </Button>
              <Button
                className="reset ml-3"
                data-dismiss="modal"
                aria-label="Close"
                onClick={(e) => {
                  e.preventDefault();
                  toggleShowAddEditPayment();
                }}
                variant="secondary"
              >
                Cancel
              </Button>
            </div>
          </form>

          <ResponsiveDrawerForm
            description={""}
            title={"Receipt History"}
            handleOpen={() => {}}
            handleClose={() => {
              setShowHistory(false);
              setHistorySubAssetId();
            }}
            buttonText={""}
            className={""}
            open={showHistory}
            buttonClassName={""}
            setOpen={setShowHistory}
            write={true}
          >
            <ReceiptItemsBasedOnSubAsset
              initialSubAssetId={historySubAssetId}
              is_payment={true}
            />
          </ResponsiveDrawerForm>
        </>
      )}
    </Formik>
  );
};

export default AddEditPayment;
